// ======================= GLOBAL STATE ======================= //
let GLOBAL_CATALOG = {
  "meta": {
    "currency": "$",
    "defaultPrice": 10,
    "uiLabels": {
      "mainProductsTab": "Lintels & T-Bars",
      "accessoriesTab": "Accessories",
      "emptyCart": "No items selected",
      "proceedCheckout": "Proceed to Checkout",
      "saveQuote": "Save Quote",
      "reviewCart": "Review Cart"
    }
  },
  "mainProducts": {
    "angleBars": {
      "id": "angleBarsPK",
      "label": "Angle Bars",
      "hasFamily": true,
      "families": {
        "budaBar": {
          "id": "budaBar",
          "label": "Buda Bar",
          "products": [
            {
              "id": "7690653401306",
              "label": "100X100X6",
              "image":"https://cdn.shopify.com/s/files/1/0610/1011/6826/files/12_76e2da46-cceb-4442-96d9-c0af76e15f41.png?v=1773849467",
              "lengths": [
                { "value": 900, "unit": "mm", "price": 26.50, "variantId":42951902068954 },
                { "value": 1200, "unit": "mm", "price": 35.33, "variantId":42951902101722 },
                { "value": 1500, "unit": "mm", "price": 44.17, "variantId":42951902134490 },
                { "value": 1800, "unit": "mm", "price": 53.00, "variantId":42951902167258 },
                { "value": 2100, "unit": "mm", "price": 61.83, "variantId":42951902200026 },
                { "value": 2400, "unit": "mm", "price": 70.66, "variantId":42951902232794 },
                { "value": 2700, "unit": "mm", "price": 79.50, "variantId":42951902265562 }
              ]
            },
            {
              "id": "7690654023898",
              "label": "150X100X6",
              "image":"https://cdn.shopify.com/s/files/1/0610/1011/6826/files/9_060ad523-d159-4ef6-8438-dc11764955b9.png?v=1773849467",
              "lengths": [
                { "value": 1800, "unit": "mm", "price": 68.45, "variantId":42951902855386 },
                { "value": 2100, "unit": "mm", "price": 79.86, "variantId":42951902888154 },
                { "value": 2400, "unit": "mm", "price": 91.27, "variantId":42951902920922 },
                { "value": 2700, "unit": "mm", "price": 102.67, "variantId":42951902953690 },
                { "value": 3000, "unit": "mm", "price": 114.08, "variantId":42951903117530 },
                { "value": 3300, "unit": "mm", "price": 125.49, "variantId":42951903150298 },
                { "value": 3600, "unit": "mm", "price": 136.91, "variantId":42951903183066 },
                { "value": 4000, "unit": "mm", "price": 152.11, "variantId":42951903215834 }
              ]
            }
          ]
        },
        "rBar": {
          "id": "rBar",
          "label": "R-Bar",
          "products": [
            {
              "id": "7690656481498",
              "label": "100X100X6",
              "image":"https://cdn.shopify.com/s/files/1/0610/1011/6826/files/16_2360f2e7-710b-49cc-aa73-cab93310252e.png?v=1773849340",
              "lengths": [
                { "value": 900, "unit": "mm", "price": 33.50, "variantId":42951910785242 },
                { "value": 1200, "unit": "mm", "price": 44.67, "variantId":42951910818010 },
                { "value": 1500, "unit": "mm", "price": 55.84, "variantId":42951910850778 },
                { "value": 1800, "unit": "mm", "price": 67.00, "variantId":42951910883546 },
                { "value": 2100, "unit": "mm", "price": 78.17, "variantId":42951910916314 },
                { "value": 2400, "unit": "mm", "price": 89.34, "variantId":42951910949082 }
              ]
            },
            {
              "id": "7690657366234",
              "label": "150X100X6",
              "image":"https://cdn.shopify.com/s/files/1/0610/1011/6826/files/17_1af081d0-f9ac-45e8-86f3-2f39156da750.png?v=1773849341",
              "lengths": [
                { "value": 1800, "unit": "mm", "price": 85.89, "variantId":42951916814554 },
                { "value": 2100, "unit": "mm", "price": 100.21, "variantId":42968191434970 },
                { "value": 2400, "unit": "mm", "price": 114.52, "variantId":42968191467738 },
                { "value": 2700, "unit": "mm", "price": 128.84, "variantId":42968191500506 },
                { "value": 3000, "unit": "mm", "price": 143.15, "variantId":42968191533274 },
                { "value": 3300, "unit": "mm", "price": 157.47, "variantId":42968191566042 },
                { "value": 3600, "unit": "mm", "price": 171.78, "variantId":42968191598810 },
                { "value": 4000, "unit": "mm", "price": 190.87, "variantId":42968191631578 }
              ]
            }
          ]
        },
        "hotRolledAngle": {
          "id": "hotRolledAngle",
          "label": "Hot Rolled Angle",
          "products": [
            {
              "id": "7690048471258",
              "label": "100X100X8",
              "image":"https://cdn.shopify.com/s/files/1/0610/1011/6826/files/4_992e3d01-ea11-444a-b3ba-67417750f25d.png?v=1773848153",
              "lengths": [
                { "value": 900, "unit": "mm", "price": 55.00, "variantId":42949356257498 },
                { "value": 1200, "unit": "mm", "price": 73.34, "variantId":42949356290266 },
                { "value": 1500, "unit": "mm", "price": 91.66, "variantId":42949356323034 },
                { "value": 1800, "unit": "mm", "price": 110.00, "variantId":42949356355802 },
                { "value": 2100, "unit": "mm", "price": 128.34, "variantId":42949356388570 },
                { "value": 2400, "unit": "mm", "price": 146.66, "variantId":42949356421338 },
                { "value": 2700, "unit": "mm", "price": 164.99, "variantId":46832621617370 }
              ]
            },
            {
              "id": "7690061676762",
              "label": "150X100X10",
              "image":"https://cdn.shopify.com/s/files/1/0610/1011/6826/files/3_6dc42989-bd9d-4d20-9238-f20ed14f99dc.png?v=1773848153",
              "lengths": [
                { "value": 1800, "unit": "mm", "price": 247.64, "variantId":42949389058266 },
                { "value": 2100, "unit": "mm", "price": 288.92, "variantId":42949389091034 },
                { "value": 2400, "unit": "mm", "price": 330.19, "variantId":42949389123802 },
                { "value": 2700, "unit": "mm", "price": 371.46, "variantId":42949390041306 },
                { "value": 3000, "unit": "mm", "price": 412.73, "variantId":42949390074074 },
                { "value": 3300, "unit": "mm", "price": 454.00, "variantId":42949390106842 },
                { "value": 3600, "unit": "mm", "price": 495.28, "variantId":42949390139610 },
                { "value": 4000, "unit": "mm", "price": 550.31, "variantId":42949390172378 },
                { "value": 4500, "unit": "mm", "price": 619.10, "variantId":42949390205146 },
                { "value": 5000, "unit": "mm", "price": 687.89, "variantId":42949390237914 },
                { "value": 5500, "unit": "mm", "price": 756.68, "variantId":42949390270682 },
                { "value": 6000, "unit": "mm", "price": 825.46, "variantId":42949390303450 }
              ]
            },
            {
              "id": "7690072817882",
              "label": "150X100X12",
              "image":"https://cdn.shopify.com/s/files/1/0610/1011/6826/files/2_356fb3b1-596e-4343-b77c-633a093fc02e.png?v=1773848153",
              "lengths": [
                { "value": 4000, "unit": "mm", "price": 942.84, "variantId":42949433786586 },
                { "value": 6000, "unit": "mm", "price": 1414.25, "variantId":42949434081498 }
              ]
            }
          ]
        }
      }
    },
    "flatBars": {
      "id": "flatBars",
      "label": "Flat Bars",
      "hasFamily": false,
      "products": [
        {
          "id": "7432671101146",
          "label": "85X7",
          "image":"https://cdn.shopify.com/s/files/1/0610/1011/6826/files/14_5bfb215e-c5de-4cee-a110-bd6a9c5ac395.png?v=1773849223",
          "lengths": [
            { "value": 800, "unit": "mm", "price": 15.08, "variantId":42949246353626 },
            { "value": 900, "unit": "mm", "price": 16.96, "variantId":42949246386394 },
            { "value": 1000, "unit": "mm", "price": 18.85, "variantId":42949246419162 },
            { "value": 1100, "unit": "mm", "price": 20.74, "variantId":42949246451930 },
            { "value": 1200, "unit": "mm", "price": 22.62, "variantId":43035396702426 }
          ]
        },
        {
          "id": "7690006986970",
          "label": "75X10",
          "image":"https://cdn.shopify.com/s/files/1/0610/1011/6826/files/13_6d5106ff-7a76-4438-8770-a8b011598870.png?v=1773849223",
          "lengths": [
            { "value": 700, "unit": "mm", "price": 18.65, "variantId":42949217550554 },
            { "value": 800, "unit": "mm", "price": 21.32, "variantId":42949212569818 },
            { "value": 900, "unit": "mm", "price": 23.98, "variantId":42949212602586 },
            { "value": 1000, "unit": "mm", "price": 26.64, "variantId":42949212635354 },
            { "value": 1100, "unit": "mm", "price": 29.30, "variantId":42949212668122 },
            { "value": 1200, "unit": "mm", "price": 31.97, "variantId":42949212700890 },
            { "value": 1300, "unit": "mm", "price": 34.64, "variantId":42949217583322 },
            { "value": 1400, "unit": "mm", "price": 37.30, "variantId":42949217616090 },
            { "value": 1500, "unit": "mm", "price": 39.96, "variantId":42949212733658 },
            { "value": 1800, "unit": "mm", "price": 47.96, "variantId":42949212766426 },
            { "value": 1900, "unit": "mm", "price": 50.62, "variantId":42949217714394 },
            { "value": 2000, "unit": "mm", "price": 53.28, "variantId":42949212799194 }
          ]
        },
        {
          "id": "7690003611866",
          "label": "100X10",
          "image":"https://cdn.shopify.com/s/files/1/0610/1011/6826/files/15_99b05c0c-b45c-47a3-b82f-c772a6e41dcb.png?v=1773849223",
          "lengths": [
            { "value": 800, "unit": "mm", "price": 44.75, "variantId":42949203296474 },
            { "value": 900, "unit": "mm", "price": 50.35, "variantId":42949203329242 },
            { "value": 1000, "unit": "mm", "price": 55.95, "variantId":42949203362010 },
            { "value": 1200, "unit": "mm", "price": 61.53, "variantId":42949203394778 },
            { "value": 1500, "unit": "mm", "price": 67.13, "variantId":42949203427546 },
            { "value": 2000, "unit": "mm", "price": 83.91, "variantId":42949203460314 }
          ]
        }
      ]
    },
    "concreteLintels": {
      "id": "concreteLintels",
      "label": "Concrete Lintels",
      "hasFamily": false,
      "products": [
        {
          "id": "7690018816218",
          "label": "110X80",
          "image":"https://cdn.shopify.com/s/files/1/0610/1011/6826/files/7_437e1072-02e3-4320-8498-d274cdc81273.png?v=1773849605",
          "lengths": [
            { "value": 1000, "unit": "mm", "price": 51.00, "variantId":42949259428058 },
            { "value": 1200, "unit": "mm", "price": 61.20, "variantId":42949259460826 },
            { "value": 1500, "unit": "mm", "price": 76.50, "variantId":42949259493594 },
            { "value": 1800, "unit": "mm", "price": 91.80, "variantId":42949259526362 },
            { "value": 2100, "unit": "mm", "price": 107.10, "variantId":42949259559130 },
            { "value": 2400, "unit": "mm", "price": 122.40, "variantId":42949259591898 },
            { "value": 2700, "unit": "mm", "price": 137.70, "variantId":42949259624666 },
            { "value": 3000, "unit": "mm", "price": 153.00, "variantId":42949259657434 },
            { "value": 3300, "unit": "mm", "price": 168.30, "variantId":42949259690202 },
            { "value": 3600, "unit": "mm", "price": 183.60, "variantId":42949259722970 }
          ]
        },
        {
          "id": "7690022781146",
          "label": "170X110",
          "image":"https://cdn.shopify.com/s/files/1/0610/1011/6826/files/8_4be34eed-6b31-4b32-9000-e7c2abb42f14.png?v=1773849603",
          "lengths": [
            { "value": 1800, "unit": "mm", "price": 153.56, "variantId":42949269323994 },
            { "value": 2400, "unit": "mm", "price": 204.75, "variantId":42949269389530 },
            { "value": 3000, "unit": "mm", "price": 255.93, "variantId":42949269455066 },
            { "value": 3600, "unit": "mm", "price": 307.12, "variantId":42949269520602 },
            { "value": 4200, "unit": "mm", "price": 358.31, "variantId":42949271060698 },
            { "value": 4800, "unit": "mm", "price": 409.49, "variantId":46319845114074 }
          ]
        }
      ]
    },
    "tBars": {
      "id": "tBars",
      "label": "T-Bars",
      "hasFamily": false,
      "products": [
        {
          "id": "7432679850202",
          "label": "Traditional T-Bar",
          "image":"https://cdn.shopify.com/s/files/1/0610/1011/6826/files/5_dcce9fba-c6ca-4c2c-b6e4-9a9bcca64b36.png?v=1773850279",
          "lengths": [
            { "value": 900, "dimensions":"(200mm x 6mm (B) / 200mm x 6mm (V))", "unit": "mm", "price": 105.75, "variantId":43096032510170 },
            { "value": 1200, "dimensions":"(200mm x 6mm (B) / 200mm x 6mm (V))", "unit": "mm", "price": 141.00, "variantId":43096032542938 },
            { "value": 1500, "dimensions":"(200mm x 6mm (B) / 200mm x 6mm (V))", "unit": "mm", "price": 176.25, "variantId":43096032575706 },
            { "value": 1800, "dimensions":"(200mm x 6mm (B) / 200mm x 6mm (V))", "unit": "mm", "price": 211.51, "variantId":43096032608474 },
            { "value": 2100, "dimensions":"(200mm x 6mm (B) / 200mm x 6mm (V))", "unit": "mm", "price": 246.75, "variantId":43096032641242 },
            { "value": 2400, "dimensions":"(200mm x 6mm (B) / 200mm x 8mm (V))", "unit": "mm", "price": 322.27, "variantId":43096032674010 },
            { "value": 2700, "dimensions":"(200mm x 6mm (B) / 200mm x 8mm (V))", "unit": "mm", "price": 362.55, "variantId":43096032706778 },
            { "value": 3000, "dimensions":"(200mm x 6mm (B) / 200mm x 8mm (V))", "unit": "mm", "price": 402.83, "variantId":43096032739546 },
            { "value": 3300, "dimensions":"(200mm x 6mm (B) / 200mm x 8mm (V))", "unit": "mm", "price": 443.11, "variantId":43096032772314 },
            { "value": 3600, "dimensions":"(200mm x 6mm (B) / 200mm x 8mm (V))", "unit": "mm", "price": 483.40, "variantId":43096032805082 },
            { "value": 3900, "dimensions":"(200mm x 6mm (B) / 200mm x 10mm (V))", "unit": "mm", "price": 589.16, "variantId":43096032837850 },
            { "value": 4200, "dimensions":"(200mm x 6mm (B) / 200mm x 10mm (V))", "unit": "mm", "price": 634.48, "variantId":43096032870618 },
            { "value": 4500, "dimensions":"(200mm x 6mm (B) / 200mm x 10mm (V))", "unit": "mm", "price": 679.80, "variantId":43096032903386 },
            { "value": 4800, "dimensions":"(200mm x 6mm (B) / 200mm x 10mm (V))", "unit": "mm", "price": 725.12, "variantId":43096032936154 },
            { "value": 5100, "dimensions":"(200mm x 6mm (B) / 200mm x 10mm (V))", "unit": "mm", "price": 770.44, "variantId":43096032968922 },
            { "value": 5400, "dimensions":"(200mm x 6mm (B) / 200mm x 10mm (V))", "unit": "mm", "price": 815.76, "variantId":43096033001690 },
            { "value": 5700, "dimensions":"(200mm x 6mm (B) / 200mm x 10mm (V))", "unit": "mm", "price": 861.08, "variantId":43096033034458 },
            { "value": 6000, "dimensions":"(200mm x 10mm (B) / 200mm x 10mm (V))", "unit": "mm", "price": 1087.38, "variantId":43096033067226 },
            { "value": 6300, "dimensions":"(200mm x 10mm (B) / 200mm x 10mm (V))", "unit": "mm", "price": 1141.76, "variantId":43096033099994 }
          ]
        },
        {
          "id": "7432679915738",
          "label": "Maxi T Bar (Cavity Wall)",
          "image":"https://cdn.shopify.com/s/files/1/0610/1011/6826/files/6_3b768fcb-6cd5-4fea-bcea-f4211141a2e4.png?v=1773850279",
          "lengths": [
            { "value": 2700, "unit": "mm", "price": 810.27, "variantId":41987964502234 },
            { "value": 3000, "unit": "mm", "price": 900.30, "variantId":41987964535002 },
            { "value": 3300, "unit": "mm", "price": 990.33, "variantId":41987964567770 },
            { "value": 3600, "unit": "mm", "price": 1080.35, "variantId":41987964600538 },
            { "value": 4000, "unit": "mm", "price": 1170.39, "variantId":41987964633306 },
            { "value": 4200, "unit": "mm", "price": 1260.41, "variantId":41987964666074 },
            { "value": 4500, "unit": "mm", "price": 1350.45, "variantId":41987964698842 },
            { "value": 4800, "unit": "mm", "price": 1440.47, "variantId":41987964731610 },
            { "value": 5100, "unit": "mm", "price": 1530.51, "variantId":41987964764378 },
            { "value": 5400, "unit": "mm", "price": 1620.53, "variantId":41987964797146 },
            { "value": 5700, "unit": "mm", "price": 1710.57, "variantId":41987964829914 },
            { "value": 6000, "unit": "mm", "price": 1800.59, "variantId":41987964862682 },
            { "value": 6300, "unit": "mm", "price": 1890.63, "variantId":41987964895450 }
          ]
        }
      ]
    }
  },
  "accessories": {
    "bricksSandCement": {
      "id": "bricksSandCement",
      "label": "Bricks / Sand / Cement",
      "products":[
        { 
          "id": "9183773622490", 
          "label": "Builder's Cement - 20KG Bag",
          "image":"https://cdn.shopify.com/s/files/1/0610/1011/6826/files/20.png?v=1773850667",
          "hasVariants":false,
          "variantId":"47642761068762",
          "price": 10.00
        },
        { 
          "id": "9183769788634", 
          "label": "Off White Cement - 20KG Bag",
          "image":"https://cdn.shopify.com/s/files/1/0610/1011/6826/files/21.png?v=1773850667",
          "hasVariants":false,
          "variantId":"47642757005530",
          "price": 16.00
        },
        { 
          "id": "9183765463258", 
          "label": "Scratch Face Common Bricks - Pallet of 400 Bricks",
          "image":"https://cdn.shopify.com/s/files/1/0610/1011/6826/files/18_cde1362a-83bb-4184-aadb-bbdd59f7fa99.png?v=1773850667",
          "hasVariants":false,
          "variantId":"47642748289242",
          "price": 362.00
        },
        { 
          "id": "9183759565018", 
          "label": "Bricklayer's Sand - 1 Tonne Bulka Bag",
          "image":"https://cdn.shopify.com/s/files/1/0610/1011/6826/files/19_4b141e0a-f54a-4694-9248-83a035262b47.png?v=1773850667",
          "hasVariants":false,
          "variantId":"47642741932250",
          "price": 101.50
        }
      ]
    },
    "flashingDampcourse": {
      "id": "flashingDampcourse",
      "label": "Flashing & Dampcourse",
      "products": [
        { 
          "id": "7433898426586", 
          "label": "Alcor Aluminium Flashing & Dampcourse",
          "image":"https://www.buda.com.au/cdn/shop/files/alcor-aluminium-flashing-and-dampcourse_8e63d7d2-8cbe-4700-b0fc-2e8acf888420.png",
          "hasVariants":true, 
          "variantOptions":["width","roll_length"],
          "optionValues":{
            "width":['110mm', '230mm', '300mm', '350mm', '380mm', '450mm', '600mm'],
            "roll_length":['10m', '30m']
          },
          "variants":{
            "110mm|10m":{
              "id": "41989042733274",
              "title": "110mm / 10m",
              "price": 17.23,
            },
            "110mm|30m":{
              "id": "41989042766042",
              "title": "110mm / 30m",
              "price": 51.18,
            },
            "230mm|10m":{
              "id": "41989042798810",
              "title": "230mm / 10m",
              "price": 43.13,
            },
            "230mm|30m":{
              "id": "41989042831578",
              "title": "230mm / 30m",
              "price": 106.73,
            },
            "300mm|10m":{
              "id": "41989042864346",
              "title": "300mm / 10m",
              "price": 54.02,
            },
            "300mm|30m":{
              "id": "41989042897114",
              "title": "300mm / 30m",
              "price": 139.20,
            },
            "350mm|10m":{
              "id": "41989042929882",
              "title": "350mm / 10m",
              "price": 65.62,
            },
            "350mm|30m":{
              "id": "41989042962650",
              "title": "350mm / 30m",
              "price": 162.16,
            },
            "380mm|10m":{
              "id": "41989118820570",
              "title": "380mm / 10m",
              "price": 70.98,
            },
            "380mm|30m":{
              "id": "41989118853338",
              "title": "380mm / 30m",
              "price": 176.26,
            },
            "450mm|10m":{
              "id": "41989042995418",
              "title": "450mm / 10m",
              "price": 92.47,
            },
            "450mm|30m":{
              "id": "41989043028186",
              "title": "450mm / 30m",
              "price": 208.65,
            },
            "600mm|10m":{
              "id": "41989043060954",
              "title": "600mm / 10m",
              "price": 107.24,
            },
            "600mm|30m":{
              "id": "41989043093722",
              "title": "600mm / 30m",
              "price": 278.36,
            }
          }
        },
        { 
          "id": "7433916121306", 
          "label": "Plastic Dampcourse", 
          "image":"https://www.buda.com.au/cdn/shop/files/plastic-dampcourse-flashing.png",
          "hasVariants":true, 
          "variantOptions":["size"],
          "optionValues":{
            "size":['110mm wide x 30m roll', '150mm wide x 30m roll', '230mm wide x 30m roll', '300mm wide x 30m roll', '350mm wide x 30m roll', '380mm wide x 30m roll', '450mm wide x 30m roll', '600mm wide x 30m roll']
          },
          "variants":{
            "110mm wide x 30m roll":{
              "id": "41989117542618",
              "title": "110mm wide x 30m roll",
              "price": 13.98,
            },
            "150mm wide x 30m roll":{
              "id": "41989117575386",
              "title": "150mm wide x 30m roll",
              "price": 19.17,
            },
            "230mm wide x 30m roll":{
              "id": "41989117608154",
              "title": "230mm wide x 30m roll",
              "price": 26.37,
            },
            "300mm wide x 30m roll":{
              "id": "41989117640922",
              "title": "300mm wide x 30m roll",
              "price": 38.17,
            },
            "350mm wide x 30m roll":{
              "id": "41989117673690",
              "title": "350mm wide x 30m roll",
              "price": 41.81,
            },
            "380mm wide x 30m roll":{
              "id": "41989117706458",
              "title": "380mm wide x 30m roll",
              "price": 46.95,
            },
            "450mm wide x 30m roll":{
              "id": "41989117739226",
              "title": "450mm wide x 30m roll",
              "price": 53.17,
            },
            "600mm wide x 30m roll":{
              "id": "41989117771994",
              "title": "600mm wide x 30m roll",
              "price": 71.45,
            }
          }
        },
        { 
          "id": "7433963831514", 
          "label": "Malthoid Flashing",
          "image":"https://www.buda.com.au/cdn/shop/files/malthoid-flashing-and-waterproofing-membrane.png",
          "hasVariants":true, 
          "variantOptions":["size_-_20_metre_roll"],
          "optionValues":{
            "size_-_20_metre_roll":['110mm 2-PLY', '150mm 2-PLY', '230mm 2-PLY', '280mm 2-PLY']
          },
          "variants":{
            "110mm 2-PLY":{
              "id": "41989315231962",
              "title": "110mm 2-PLY",
              "price": 24.24,
            },
            "150mm 2-PLY":{
              "id": "41989315264730",
              "title": "150mm 2-PLY",
              "price": 33.07,
            },
            "230mm 2-PLY":{
              "id": "41989315297498",
              "title": "230mm 2-PLY",
              "price": 50.70,
            },
            "280mm 2-PLY":{
              "id": "41989315330266",
              "title": "280mm 2-PLY",
              "price": 61.72,
            }
          }
        }
      ]
    },
    "wallTies": {
      "id": "wallTies",
      "label": "Wall Ties",
      "products": [
        { 
          "id": "7515456831706", 
          "label": "Brick Wall Ties",
          "hasVariants":true, 
          "variantOptions":["material","quantity","length"],
          "optionValues":{
            "length":['175mm (230mm Wall)', '225mm (270mm Wall w Cavity)'],
            "material":['Galvanised'],
            "quantity":['Bundle of 50 pcs', 'Box of 500 pcs']
          },
          "variants":{
            "Galvanised|Bundle of 50 pcs|175mm (230mm Wall)":{
              "id": "42293933965530",
              "title": "Galvanised / Bundle of 50 pcs / 175mm (230mm Wall)",
              "image":"https://cdn.shopify.com/s/files/1/0610/1011/6826/files/22.png?v=1773850666",
              "price": 20.50,
            },
            "Galvanised|Bundle of 50 pcs|225mm (270mm Wall w Cavity)":{
              "id": "47346519867610",
              "title": "Galvanised / Bundle of 50 pcs / 225mm (270mm Wall w Cavity)",
              "image":"https://cdn.shopify.com/s/files/1/0610/1011/6826/files/22.png?v=1773850666",
              "price": 30.00,
            },
            "Galvanised|Box of 500 pcs|175mm (230mm Wall)":{
              "id": "42293933998298",
              "title": "Galvanised / Box of 500 pcs / 175mm (230mm Wall)",
              "image":"https://cdn.shopify.com/s/files/1/0610/1011/6826/files/22.png?v=1773850666",
              "price": 121.00,
            },
            "Galvanised|Box of 500 pcs|225mm (270mm Wall w Cavity)":{
              "id": "47346519900378",
              "title": "Galvanised / Box of 500 pcs / 225mm (270mm Wall w Cavity)",
              "image":"https://cdn.shopify.com/s/files/1/0610/1011/6826/files/22.png?v=1773850666",
              "price": 140.00,
            },
            // "Stainless Steel|Bundle of 50 pcs|175mm (230mm Wall)":{
            //   "id": "44320582729946",
            //   "title": "Stainless Steel / Bundle of 50 pcs / 175mm (230mm Wall)",
            //   "image":"https://www.buda.com.au/cdn/shop/files/stainless_wall_tie_2.jpg",
            //   "price": 66.00,
            // },
            // "Stainless Steel|Box of 500 pcs|175mm (230mm Wall)":{
            //   "id": "44320582762714",
            //   "title": "Stainless Steel / Box of 500 pcs / 175mm (230mm Wall)",
            //   "image":"https://www.buda.com.au/cdn/shop/files/stainless_wall_tie_2.jpg",
            //   "price": 324.50,
            // },
            // "Stainless Steel|Box of 250 pcs|175mm (230mm Wall)":{
            //   "id": 44320582795482,
            //   "product_id": 7515456831706,
            //   "title": "Stainless Steel / Box of 250 pcs / 175mm (230mm Wall)",
            //   "image":"https://www.buda.com.au/cdn/shop/files/stainless_wall_tie_2.jpg",
            //   "price": 181.50,
            // }
          }
        },
        { 
          "id": "7515460567258", 
          "label": "Stubby Brick Ties (L-Shaped)",
          "image":"https://www.buda.com.au/cdn/shop/files/WallTieStubbyx8.jpg",
          "hasVariants":true, 
          "variantOptions":["material","duty"],
          "optionValues":{
            "material":['Galvanised', 'Stainless Steel'],
            "duty":['Light Duty', 'Medium Duty'],
          },
          "variants":{
            "Galvanised|Light Duty":{
              "id": "44320574177498",
              "title": "Galvanised / Light Duty",
              "price": 39.05,
            },
            "Galvanised|Medium Duty":{
              "id": "47346553127130",
              "title": "Galvanised / Medium Duty",
              "price": 57.72,
            },
            "Stainless Steel|Light Duty":{
              "id": "44320574210266",
              "title": "Stainless Steel / Light Duty",
              "price": 71.50,
            }
          }
        },
        { 
          "id": "8151997612250", 
          "label": "Veneer Ties (Twisted Ties)",
          "image":"https://www.buda.com.au/cdn/shop/files/VeneerTie1.jpg",
          "hasVariants":true, 
          "variantOptions":["material"],
          "optionValues":{
            "material":['Galvanised', 'Stainless Steel'],
          },
          "variants":{
            "Galvanised":{
              "id": "44320576897242",
              "title": "Galvanised",
              "price": 43.78,
            },
            "Stainless Steel":{
              "id": "44320576930010",
              "title": "Stainless Steel",
              "price": 71.50,
            }
          }
        },
        { 
          "id": "8152000233690", 
          "label": "Frame Ties (L-Shaped)",
          "image":"https://www.buda.com.au/cdn/shop/files/WallTieFrame_1.jpg",
          "hasVariants":false,
          "variantId":"44320493666522",
          "price": 57.20 
        },
        { 
          "id": "7516542435546", 
          "label": "Expansion Ties for Brick & Double Brick Walls",
          "image":"https://www.buda.com.au/cdn/shop/files/ExpansionTie.jpg",
          "hasVariants":true, 
          "variantOptions":["material"],
          "optionValues":{
            "material":['Galvanised', 'Stainless Steel'],
          },
          "variants":{
            "Galvanised":{
              "id": "44320570671322",
              "title": "Galvanised",
              "price": 42.46,
            },
            "Stainless Steel":{
              "id": "44320570704090",
              "title": "Stainless Steel",
              "price": 102.30,
            }
          } 
        }
      ]
    },
    "otherAccessories": {
      "id": "otherAccessories",
      "label": "Other Accessories",
      "products": [
        { 
          "id": "7436749734106", 
          "label": "Hoop Iron (Punch Strap)",
          "image":"https://www.buda.com.au/cdn/shop/files/hoop-iron-punch-strap-for-roofing.png",
          "hasVariants":true, 
          "variantOptions":["roll_size"],
          "optionValues":{
            "roll_size":['30mm x 15m', '30mm x 30m'],
          },
          "variants":{
            "30mm x 15m":{
              "id": "42019482206426",
              "title": "30mm x 15m",
              "price": 31.41,
            },
            "30mm x 30m":{
              "id": "42019482239194",
              "title": "30mm x 30m",
              "price": 49.01,
            }
          }
        },
        { 
          "id": "7433931227354", 
          "label": "Abelflex – Expansion Joint Foam", 
          "hasVariants":true, 
          "variantOptions":["size_-_20_metre_roll","sticky_or_non-sticky"],
          "optionValues":{
            "size_-_20_metre_roll":['50mm', '75mm', '100mm', '125mm', '150mm', '200mm', '300mm'],
            "sticky_or_non-sticky":['Non-Sticky', 'Sticky'],
          },
          "variants":{
            "50mm|Non-Sticky":{
              "id": "47346572919002",
              "title": "50mm / Non-Sticky",
              "image":"https://www.buda.com.au/cdn/shop/files/IMG_6108.jpg",
              "price": 25.48,
            },
            "75mm|Non-Sticky":{
              "id": "41989181571290",
              "title": "75mm / Non-Sticky",
              "image":"https://www.buda.com.au/cdn/shop/files/IMG_6108.jpg",
              "price": 36.80,
            },
            "75mm|Sticky":{
              "id": "47346572951770",
              "title": "75mm / Sticky",
              "image":"https://www.buda.com.au/cdn/shop/files/150mm-Foamjoint_jpg.webp",
              "price": 51.47,
            },
            "100mm|Non-Sticky":{
              "id": "41989181636826",
              "title": "100mm / Non-Sticky",
              "image":"https://www.buda.com.au/cdn/shop/files/IMG_6108.jpg",
              "price": 54.33,
            },
            "100mm|Sticky":{
              "id": "47346572984538",
              "title": "100mm / Sticky",
              "image":"https://www.buda.com.au/cdn/shop/files/150mm-Foamjoint_jpg.webp",
              "price": 68.55,
            },
            "125mm|Non-Sticky":{
              "id": "41989181702362",
              "title": "125mm / Non-Sticky",
              "image":"https://www.buda.com.au/cdn/shop/files/IMG_6108.jpg",
              "price": 61.14,
            },
            "125mm|Sticky":{
              "id": "47346573017306",
              "title": "125mm / Sticky",
              "image":"https://www.buda.com.au/cdn/shop/files/150mm-Foamjoint_jpg.webp",
              "price": 80.49,
            },
            "150mm|Non-Sticky":{
              "id": "41989181735130",
              "title": "150mm / Non-Sticky",
              "image":"https://www.buda.com.au/cdn/shop/files/IMG_6108.jpg",
              "price": 72.56,
            },
            "150mm|Sticky":{
              "id": "47346573050074",
              "title": "150mm / Sticky",
              "image":"https://www.buda.com.au/cdn/shop/files/150mm-Foamjoint_jpg.webp",
              "price": 81.60,
            },
            "200mm|Non-Sticky":{
              "id": "41989181800666",
              "title": "200mm / Non-Sticky",
              "image":"https://www.buda.com.au/cdn/shop/files/IMG_6108.jpg",
              "price": 95.69,
            },
            "200mm|Sticky":{
              "id": "47346573082842",
              "title": "200mm / Sticky",
              "image":"https://www.buda.com.au/cdn/shop/files/150mm-Foamjoint_jpg.webp",
              "price": 115.18,
            },
            "300mm|Non-Sticky":{
              "id": "41989181866202",
              "title": "300mm / Non-Sticky",
              "image":"https://www.buda.com.au/cdn/shop/files/IMG_6108.jpg",
              "price": 132.57,
            },
            "300mm|Sticky":{
              "id": "47346573115610",
              "title": "300mm / Sticky",
              "image":"https://www.buda.com.au/cdn/shop/files/150mm-Foamjoint_jpg.webp",
              "price": 132.57,
            }
          }
        },
        { 
          "id": "7436749406426",
          "label": "Weepas for Brickwork",
          "hasVariants":true, 
          "variantOptions":["type"],
          "optionValues":{
            "type":['Standard (Pack of 25)', 'Bushfire (Pack of 25)'],
          },
          "variants":{
            "Standard (Pack of 25)":{
              "id": "42019480273114",
              "title": "Standard (Pack of 25)",
              "image":"https://www.buda.com.au/cdn/shop/files/weepas-for-brickwork-25-pack--1.png",
              "price": 49.50,
            },
            "Bushfire (Pack of 25)":{
              "id": "42019480305882",
              "title": "Bushfire (Pack of 25)",
              "image":"https://www.buda.com.au/cdn/shop/files/weepas-for-brickwork-25-pack--2.png",
              "price": 82.50,
            }
          }
        },
        { 
          "id": "8730770079962",
          "label": "Rendermesh",
          "image":"https://www.buda.com.au/cdn/shop/files/Untitleddesign_80_b5cbcf91-f824-475f-9844-e925338dfe59.png",
          "hasVariants":false,
          "variantId":"46010976665818",
          "price": 25.00
        }
      ]
    }
  }
};
let cartState = {
  mainProducts: {
    "angleBars":{
      "budaBar":{ 
        "7690653401306": [],
        "7690654023898": []
      },
      "rBar":{ 
        "7690656481498": [],
        "7690657366234": []
      },
      "hotRolledAngle":{ 
        "7690048471258": [],
        "7690061676762": [],
        "7690072817882": []
      },
    },
    "concreteLintels":{
      "7690018816218":[],
      "7690022781146":[]
    },
    "flatBars":{
      "7432671101146":[],
      "7690006986970":[],
      "7690003611866":[]
    },
    "tBars":{
      "7432679850202":[],
      "7432679915738":[]
    }
  },
  accessories: {
    "bricksSandCement":{
      "9183773622490":[],
      "9183769788634":[],
      "9183765463258":[],
      "9183759565018":[]
    },
    "flashingDampcourse":{
      "7433898426586":{
        "41989042733274":[],
        "41989042766042":[],
        "41989042798810":[],
        "41989042831578":[],
        "41989042864346":[],
        "41989042897114":[],
        "41989042929882":[],
        "41989042962650":[],
        "41989118820570":[],
        "41989118853338":[],
        "41989042995418":[],
        "41989043028186":[],
        "41989043060954":[],
        "41989043093722":[]
      },
      "7433916121306":{
        "41989117542618":[],
        "41989117575386":[],
        "41989117608154":[],
        "41989117640922":[],
        "41989117673690":[],
        "41989117706458":[],
        "41989117739226":[],
        "41989117771994":[]
      },
      "7433963831514":{
        "41989315231962":[],
        "41989315264730":[],
        "41989315297498":[],
        "41989315330266":[]
      }
    },
    "wallTies":{
      "7515456831706":{
        "42293933965530":[],
        "47346519867610":[],
        "42293933998298":[],
        "47346519900378":[],
        "44320582729946":[],
        "44320582762714":[],
        "44320582795482":[]
      },
      "7515460567258":{
        "44320574177498":[],
        "47346553127130":[],
        "44320574210266":[]
      },
      "8151997612250":{
        "44320576897242":[],
        "44320576930010":[]
      },
      "8152000233690":[],
      "7516542435546":{
        "44320570671322":[],
        "44320570704090":[]
      }
    },
    "otherAccessories":{
      "7436749734106":{
        "42019482206426":[],
        "42019482239194":[]
      },
      "7433931227354":{
        "47346572919002":[],
        "41989181571290":[],
        "47346572951770":[],
        "41989181636826":[],
        "47346572984538":[],
        "41989181702362":[],
        "47346573017306":[],
        "41989181735130":[],
        "47346573050074":[],
        "41989181800666":[],
        "47346573082842":[],
        "41989181866202":[],
        "47346573115610":[]
      },
      "7436749406426":{
        "42019480273114":[],
        "42019480305882":[]
      },
      "8730770079962":[]
    }
  }
};
jQuery.fn.datepicker
const INITIAL_CART_STATE = JSON.parse(JSON.stringify(cartState));
let currentActiveType = 'angleBars';
let currentActiveFamily = 'budaBar';
let currentActiveCategory = null;

// ======================= INITIALIZATION ======================= //
let scrollController;
// let mobileBarFixer;
function formatCurrency(amount) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  }).format(amount);
}

function initScrollController() {
  scrollController?.destroy();          // ✅ cleanup old instance
  scrollController = windowScrollStopOnHeader();
  window.scrollController = scrollController;
}

document.addEventListener('DOMContentLoaded', async () => {  
  // Initialize UI
  initializeTabSwitcher();
  renderMainProductsScreen();
  initializeProductTypeButtons();
  renderAccessoriesScreen();
  initializeAccessoriesButtons();
  initializeCartHandlers();
  initializeModalHandlers();
  initializeMobileCart();
  setupScrollSpy();
  initScrollController();
  jQuery('[data-toggle="datepicker"]').datepicker({
    container: '.pickerContainer',
    autoHide: true,
    startDate: new Date(new Date().setDate(new Date().getDate() + 1)),
    trigger:'#whenRequired-save'
  });
  // mobileBarFixer = makeMobileBarFixer();
});

window.addEventListener("resize", () => {
  initScrollController();
  fixButtonBarsOnMobile()
});
window.addEventListener("scroll",() => {
  fixButtonBarsOnMobile()
})

// ======================= General Functions ===================== //

function isMobile(){
  const isDesktop = () =>
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  // ✅ Mobile/tablet: keep default browser behavior
  if (!isDesktop()) {
    return true
  }else{
    return false
  }
}
function fixButtonBarsOnMobile() {
  const header = document.querySelector(".header-section");  
  const appContainer = document.querySelector(".app-container");  
  const y = header.offsetTop + header.offsetHeight
  const appContainerY = appContainer.offsetTop + appContainer.offsetHeight

  // console.log('appContainerY',appContainerY);
  
  const isDesktop = () =>
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  // ✅ Mobile/tablet: keep default browser behavior
  if (!isDesktop()) {
    if(window.scrollY > y){
      document.body.classList.add("mobile-bar-fixed");
      if(window.scrollY > appContainerY - 200){
        let stickyBars = document.querySelectorAll('body.mobile-bar-fixed .sticky-bars-containers')
        stickyBars.forEach(v => {
            v.style.display = 'none'
        })
        // document.body.classList.remove("mobile-bar-fixed");
      }else{
        let stickyBars = document.querySelectorAll('body.mobile-bar-fixed .sticky-bars-containers')
        stickyBars.forEach(v => {
            v.style.display = 'block'
        })
        // document.body.classList.add("mobile-bar-fixed");
      }
    }else{
      document.body.classList.remove("mobile-bar-fixed");
    }
  }
}

function scrollUntilHeaderHidden() {
  const header = document.querySelector(".header-section");
  const y = header.offsetTop + header.offsetHeight;
    
  window.scrollTo({ top: y, behavior: "smooth" });
}

function windowScrollStopOnHeader(){

  const isDesktop = () =>
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  // ✅ Mobile/tablet: keep default browser behavior
  if (!isDesktop()) {
    return {
      refresh() {},
      scrollTo() {},
      destroy() {},
    };
  }

  const LOCK_EPS = 8;     // px: require a bit past y to lock
  const UNLOCK_EPS = 10;  // px: must go above y - 20 to allow re-lock again
  const header = document.querySelector(".header-section");
  const productsContent = document.querySelector('.products-content');
  const categoriesContent = document.querySelector('.categories-content');
  let section = productsContent ? productsContent : categoriesContent;
  let canLock = true;     // prevents immediate re-lock loops
  let snap = true
  let locked = false;
  let lockY = 0;
  let lastTouchY = null;
  let isPinning = false;
  let lastIntentDir = 0
  // --- smooth scrolling state for section ---
  let targetScrollTop = 0;
  let isAnimating = false;
  let animToken = 0;
  let isProgrammaticScroll = false;
  let activeAnimSection = null;
  let pendingLock = null; // { y, section, delta }
  

  // --- pick the actually visible section ---
  function isVisible(el) {
    if (!el) return false;
    // Fast + reliable: hidden elements will have no boxes
    if (el.getClientRects().length === 0) return false;
    // Also covers display:none, visibility:hidden, etc.
    const style = window.getComputedStyle(el);
    return style.display !== "none" && style.visibility !== "hidden";
  }

  function getActiveSection() {
    if (isVisible(productsContent)) return productsContent;
    if (isVisible(categoriesContent)) return categoriesContent;

    // fallback: if both visible/hidden weirdly, pick first non-null
    return productsContent || categoriesContent;
  }

  function getLockY() {
    return header.offsetTop + header.offsetHeight;
  }

  function getMaxWindowScrollY() {
    const doc = document.documentElement;
    const body = document.body;
    const scrollHeight = Math.max(
      doc?.scrollHeight || 0,
      body?.scrollHeight || 0
    );
    return Math.max(0, scrollHeight - window.innerHeight);
  }

  function getEffectiveLockY() {
    return Math.min(getLockY(), getMaxWindowScrollY());
  }

  

  function clampTarget(section) {
    const max = Math.max(0, section.scrollHeight - section.clientHeight);
    targetScrollTop = Math.max(0, Math.min(targetScrollTop, max));
  }

  function smoothScrollSection(section) {
    // if already animating this same section, just let it continue
    if (isAnimating && activeAnimSection === section) return;

    // if animating a different section, cancel old loop
    if (isAnimating && activeAnimSection !== section) {
      animToken++;         // cancel old loop
      isAnimating = false;
    }

    activeAnimSection = section;

    const myToken = animToken; // IMPORTANT: token only changes when we cancel explicitly
    isAnimating = true;

    const ease = 5; // 0.12 heavier, 0.25 snappier

    function animate() {
      // stop if cancelled
      if (myToken !== animToken) {
        isAnimating = false;
        return;
      }

      const current = section.scrollTop;
      const diff = targetScrollTop - current;

      // programmatic mark (so drag listener doesn't cancel us)
      isProgrammaticScroll = true;
      section.scrollTop = current + diff * ease;
      isProgrammaticScroll = false;

      if (Math.abs(diff) > 0.5) {
        requestAnimationFrame(animate);
      } else {
        isProgrammaticScroll = true;
        section.scrollTop = targetScrollTop;
        isProgrammaticScroll = false;

        isAnimating = false;
      }
    }

    requestAnimationFrame(animate);
  }
  function smoothScrollToLockY(y, section, delta) {
    // if already in progress, just update latest intent
    pendingLock = { y, section, delta };
    const targetY = Math.min(y, getMaxWindowScrollY());
    window.scrollTo({ top: targetY, left: 0, behavior: "smooth" });
    let lastY = window.scrollY;
    let stalledFrames = 0;

    // poll until we reach near y, then lock
    const check = () => {
      if (!pendingLock) return;

      const { y: targetY, section: sec, delta: d } = pendingLock;
      const reachableTargetY = Math.min(targetY, getMaxWindowScrollY());
      const currentY = window.scrollY;
      const atBottomBoundary = Math.abs(currentY - getMaxWindowScrollY()) <= 2;

      if (Math.abs(currentY - lastY) < 0.5) {
        stalledFrames++;
      } else {
        stalledFrames = 0;
      }
      lastY = currentY;

      if (
        Math.abs(currentY - reachableTargetY) <= 2 ||
        (reachableTargetY >= getMaxWindowScrollY() - 2 && atBottomBoundary) ||
        stalledFrames > 20
      ) {
        pendingLock = null;

        lockWindow();

        // now scroll the section with the same delta
        if (!isAnimating || activeAnimSection !== sec) {
          targetScrollTop = sec.scrollTop;
        }
        targetScrollTop += d;

        clampTarget(sec);
        smoothScrollSection(sec);
        return;
      }

      requestAnimationFrame(check);
    };

    requestAnimationFrame(check);
  }

  function lockWindow() {
    if (locked) return;
    locked = true;

    lockY = getEffectiveLockY();

    // snap precisely so section top touches viewport top
    if (snap) {
      window.scrollTo(0, lockY);
    }

    // lock body scroll
    document.body.classList.add("scroll-locked");

    // ensure section can scroll

    const section = getActiveSection();

    // optional: focus so keyboard arrows/page-down scroll the section
    section.setAttribute("tabindex", section.getAttribute("tabindex") || "-1");
    section.focus({ preventScroll: true });
  }

  function unlockWindow() {
    if (!locked) return;
    locked = false;

    document.body.classList.remove("scroll-locked");
    // keep section scroll enabled if you want; or disable it:
  }

  // Keep window pinned while locked
  function keepPinned() {
    // console.log('pinning func called')
    // console.log('isPinning',isPinning)
    if (!locked) return;
    
    // If we're already pinning, ignore this scroll event
    if (isPinning) return;
    
    // If we're already at the lock position (or extremely close), do nothing
    let winY = window.scrollY
    // console.log('======================================================')
    // console.log('window.scrollYyy',window.scrollY)
    // console.log('winY',winY)
    // console.log('lockY',lockY)
    // console.log('Math.abs(window.scrollY - lockY)',Math.abs(window.scrollY - lockY))
    // console.log('Math.abs(winY - lockY)',Math.abs(winY - lockY))
    // console.log('======================================================')
    if (Math.abs(winY - lockY) < 20) return;
    // console.log('are we pinning')
    isPinning = true;

    // Pin on the next frame to avoid scroll-event recursion/jitter
    requestAnimationFrame(() => {
      window.scrollTo(0, lockY);
      isPinning = false;
    });
  }

  // ✅ 1) Allow dragging scrollbar / manual scroll by syncing state
  function onSectionScroll() {
    if (!locked) return;

    const section = getActiveSection();
    if (!section) return;

    // If user moved scrollbar / keyboard scroll / trackpad momentum:
    if (!isProgrammaticScroll) {
      // cancel our animation and accept user's new position
      animToken++;
      isAnimating = false;
      targetScrollTop = section.scrollTop;
    }
  }

  // helper: is wheel happening inside the active section?
  function onWheel(e) {
    const section = getActiveSection();
    if (!section) return;

    const isInside = section.contains(e.target);
    if(!isInside){
      const elCart = document.querySelector('.cart-content');
      if(elCart.contains(e.target)){
        if(elCart.scrollHeight > elCart.clientHeight){
          return
        }
      }
      // else{
      //   console.log('no the mouse is not on the cart')
      // }
    }
    const delta = e.deltaY;
    lastIntentDir = delta > 0 ? 1 : delta < 0 ? -1 : lastIntentDir;

    // If not locked and wheel is NOT inside the section, do nothing (let window scroll normally)
    if (!locked && !isInside) return;

    // From here we will manage the scroll ourselves
    e.preventDefault();

    // Auto-lock if user scrolls inside section while window isn't locked yet
    if (!locked && isInside) {
      const sec = getActiveSection();
      if (!sec) return;


      const atTop = sec.scrollTop <= 2;
      const atBottom = Math.abs(Math.ceil(sec.scrollTop + sec.clientHeight) - sec.scrollHeight) <= 10;

      // ✅ If section can't scroll in the user's direction, DON'T lock.
      // Let the window behave normally.
      // console.log('atBottom_inside',atBottom);
      // console.log('Math.abs(Math.ceil(sec.scrollTop + sec.clientHeight))_inside',Math.abs(Math.ceil(sec.scrollTop + sec.clientHeight)));
      // console.log('sec.scrollHeight_inside',sec.scrollHeight);
      
      if ((delta < 0 && atTop) || (delta > 0 && atBottom)) {
        if(delta < 0){
          window.scrollTo({
            top: (window.scrollY - 100) > 0 ? window.scrollY - 100 : 0,
            behavior:'smooth'
          })
        }
        if(delta > 0){
          window.scrollTo({
            top: window.scrollY + 500,
            behavior:'smooth'
          })
        }
        return; // don't preventDefault; browser scrolls window
      }

      // ✅ Only now do the smooth window scroll to lock point + then section scroll
      e.preventDefault();

      const y = getLockY();
      smoothScrollToLockY(y, sec, delta);
      return;
    }

    // If we still aren't locked for any reason, bail
    if (!locked) return;

    // Re-read active section (in case tab switched)
    const active = getActiveSection();
    if (!active) return;

    const atTop = active.scrollTop <= 2;
    const atBottom =
      Math.abs(Math.ceil(active.scrollTop + active.clientHeight) - active.scrollHeight) <= 10;

    // console.log('atBottom',atBottom);
    // console.log('Math.abs(Math.ceil(active.scrollTop + active.clientHeight))',Math.abs(Math.ceil(active.scrollTop + active.clientHeight)));
    // console.log('active.scrollHeight',active.scrollHeight);
    // console.log('delta',delta);
    // Unlock on boundaries
    if (delta < 0 && atTop) {
      unlockWindow();
      // We prevented default above, so move window manually to avoid instant re-lock at same Y.
      window.scrollBy(0, delta);
      canLock = false;
      return;
    }
    if (delta > 0 && atBottom) {
      unlockWindow();
      // Allow the window to scroll further down
      // if(window.innerWidth >= 1400 && window.innerWidth <= 1500){
      //   // console.log('are we in the range');
        
      //   // window.scrollTo({
      //   //   top: window.scrollY + 100,
      //   //   behavior:'smooth'
      //   // })
      // }else{
        window.scrollBy(0, delta);
      // }
      canLock = false;
      return;
    }

    // Smooth section scroll
    targetScrollTop = active.scrollTop;
    targetScrollTop += delta;

    clampTarget(active);
    smoothScrollSection(active);
  }

  // Main scroll watcher: when user reaches the threshold, lock
  function onScroll() {
    // console.log(' i am being called')
    const y = getEffectiveLockY();
    let diff = y;

    // if user scrolled UP enough, allow locking again later

    if(lastIntentDir < 0){
      diff = y + (UNLOCK_EPS * 3.5)
    }
    if(lastIntentDir > 0){
      diff = y - UNLOCK_EPS
    }
    let windowScrollY = window.scrollY
    if (windowScrollY <= diff) {
      // console.log('Y',y);
      // console.log('UNLOCK_EPS',UNLOCK_EPS);
      // console.log('diff',diff);
      // console.log('window.scrollY',window.scrollY);
      
      canLock = true;
    }

    // lock only if allowed and we are clearly past the threshold
    const atBottomBoundary =
      y >= getMaxWindowScrollY() - 2 && window.scrollY >= y - 2;
    const nearLockLine = Math.abs(window.scrollY - y) <= LOCK_EPS;
    const movingDownOrNeutral = lastIntentDir >= 0;
    if (
      !locked &&
      canLock &&
      movingDownOrNeutral &&
      (window.scrollY >= y + LOCK_EPS || nearLockLine || atBottomBoundary)
    ) {
    // console.log('able to lock on Scroll')
      // const nearLockLine = Math.abs(diff) <= LOCK_EPS;
      lockWindow();
      canLock = false; // prevent re-lock until user goes up again
      return;
    }

    keepPinned();
  }

  function refreshActiveSectionTarget() {
    const section = getActiveSection();

    // cancel any running animation so new section can animate immediately
    animToken++;
    isAnimating = false;

    targetScrollTop = section ? section.scrollTop : 0;
  }

  function scrollSectionTo(y, { smooth = true } = {}) {
    const section = getActiveSection();
    if (!section) return;

    // 1️⃣ cancel any running custom animation
    animToken++;
    isAnimating = false;

    // 2️⃣ clamp target
    const max = Math.max(0, section.scrollHeight - section.clientHeight);
    targetScrollTop = Math.max(0, Math.min(y, max));

    // 3️⃣ perform scroll
    if (smooth) {
      requestAnimationFrame(() => {
        section.scrollTo({
          top: targetScrollTop,
          behavior: "smooth",
        });
      });
    } else {
      section.scrollTop = targetScrollTop;
    }
  }

  // Attach listeners
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("wheel", onWheel, { passive: false });

  // listen to manual section scroll so scrollbar dragging works
  productsContent?.addEventListener("scroll", onSectionScroll, { passive: true });
  categoriesContent?.addEventListener("scroll", onSectionScroll, { passive: true });

  // Initial run (if page loads mid-scroll)
  onScroll();

  function destroy() {
    window.removeEventListener("scroll", onScroll);
    window.removeEventListener("wheel", onWheel);

    productsContent?.removeEventListener("scroll", onSectionScroll);
    categoriesContent?.removeEventListener("scroll", onSectionScroll);

    document.body.classList.remove("scroll-locked");

    animToken++;
    isAnimating = false;
    locked = false;
  }

  // Return helper so you can call it after switching tab
  return {
    refresh: refreshActiveSectionTarget,
    scrollTo: scrollSectionTo,
    destroy
  };

}
async function getCartItemsObject() {
  const response = await fetch('/cart.js');
  const cartData = await response.json();
  // console.log(cartData)
  let itemsObjs = {};
  if (cartData.item_count > 0) {
    cartData.items.forEach(item => {
      itemsObjs[parseInt(item.variant_id)] = item.quantity;
    });
  }

  return itemsObjs;
}
function clearCart() {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: "/cart/clear.js",
      method: "POST",
      contentType: "application/json",
      success: function (res) {
        resolve(res);
      },
      error: function (xhr, status, error) {
        reject(error);
      }
    });
  });
}

// ======================= TAB SWITCHING ======================= //
function initializeTabSwitcher() {
  const tabButtons = document.querySelectorAll('.tab-button');
  
  tabButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      const tabName = e.target.dataset.tab;
      switchTab(tabName);
    });
  });
}

function switchTab(tabName) {
  // Update tab buttons
  document.querySelectorAll('.tab-button').forEach(btn => {
    btn.classList.remove('active');
  });
  // console.log(document.querySelectorAll(`[data-tab="${tabName}"]`))
  document.querySelectorAll(`[data-tab="${tabName}"]`).forEach(btn => {
    btn.classList.add('active');
  });
  // document.querySelector(`[data-tab="${tabName}"]`).classList.add('active');
  
  // Update screens
  document.querySelectorAll('.screen').forEach(screen => {
    screen.style.display = 'none';
  });
  document.getElementById(`${tabName}Screen`).style.display = 'flex';
  
  // Render appropriate content
  if (tabName === 'mainProducts') {
    renderMainProductsScreen();
  } else if (tabName === 'accessories') {
    renderAccessoriesScreen();
  }

  // ✅ refresh AFTER render + after layout has updated
  requestAnimationFrame(() => {
    // sometimes 1 frame is enough; if your render is heavy, use 2 frames:
    requestAnimationFrame(() => {
      window.scrollController?.refresh();

      const isDesktop = () => window.matchMedia("(hover: hover) and (pointer: fine)").matches;

      if (!isDesktop()) {
        const header = document.querySelector(".header-section");
        const y = header.offsetTop + header.offsetHeight;
        window.scrollTo({ top: y + 10, behavior: "smooth" });
        if(tabName === 'mainProducts'){
          selectProductType('angleBars')
        }
        if(tabName === 'accessories'){
          selectCategory('bricksSandCement')
        }
      }
    });
  });
}

// ======================= PRODUCT TYPE BUTTONS ======================= //
function initializeProductTypeButtons() {
    currentActiveType ? selectProductType(currentActiveType) : ''
    const typeButtons = document.querySelectorAll('.type-button');
    
    typeButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          const typeId = e.target.dataset.type;
          selectProductType(typeId);
        });
        setTimeout(() => {
          const familyBar = document.querySelector('.family-bar');
          familyBar.style.display = 'block';
        }, 100);
    });
}

function selectProductType(typeId) {
  const mobile = isMobile()
  currentActiveType = typeId;
  
  // if(mobile){
  //   // Update active state
  //   // document.querySelectorAll('.type-button').forEach(btn => {
  //   //   btn.classList.remove('active');
  //   // });
  //   // document.querySelector(`[data-type="${typeId}"]`) ? document.querySelector(`[data-type="${typeId}"]`).classList.add('active') : ''
  // }
  
  // Update family bar visibility
  const typeData = GLOBAL_CATALOG.mainProducts[typeId];
  const familyBar = document.querySelector('.family-bar');
  
  if (typeData.hasFamily) {
    const firstFamilyId = Object.keys(typeData.families)[0];
    currentActiveFamily = firstFamilyId;
    renderFamilyBar(typeId);
    if(mobile){
      // Show and populate family bar
      familyBar.style.display = 'block';
      // Set first family as active
    }
    // Scroll to first family section
    setTimeout(() => {
      scrollToSection(typeId, firstFamilyId);
    }, 50);
  } else {
    if(mobile){
      familyBar.style.display = 'none';
    }
    currentActiveFamily = null;
    
    // Scroll to type section
    setTimeout(() => {
      scrollToSection(typeId, null);
    }, 50);
  }
}

// ======================= FAMILY BAR RENDERING ======================= //
function renderFamilyBar(typeId) {
  const typeData = GLOBAL_CATALOG.mainProducts[typeId];
  const container = document.querySelector('.family-bar-container');
  container.innerHTML = '';
  
  if (!typeData.hasFamily) return;
  
  Object.keys(typeData.families).forEach((familyId, index) => {
    const family = typeData.families[familyId];
    const button = document.createElement('button');
    button.className = 'family-button';
    button.dataset.family = familyId;
    button.dataset.type = typeId;
    button.textContent = family.label;
    
    if (index === 0) button.classList.add('active');
    
    button.addEventListener('click', () => {
      selectFamily(typeId, familyId);
    });
    
    container.appendChild(button);
  });
}

function selectFamily(typeId, familyId) {
  const mobile = isMobile()
  currentActiveFamily = familyId;
  
  if(mobile){
    // Update active state
    document.querySelectorAll('.family-button').forEach(btn => {
      btn.classList.remove('active');
    });
    document.querySelector(`[data-family="${familyId}"]`).classList.add('active');
  }
  
  // Scroll to section
  setTimeout(() => {
    scrollToSection(typeId, familyId);
  }, 50);
}

// ======================= MAIN PRODUCTS SCREEN RENDERING ======================= //
function renderMainProductsScreen() {
  const contentArea = document.querySelector('.products-content');
  contentArea.innerHTML = '';
  
  // Render all product sections
  Object.keys(GLOBAL_CATALOG.mainProducts).forEach(typeId => {
    const typeData = GLOBAL_CATALOG.mainProducts[typeId];
    
    if (typeData.hasFamily) {
      // Render family sections
      Object.keys(typeData.families).forEach(familyId => {
        const family = typeData.families[familyId];
        const section = createSection(typeId, family.label, familyId);
        contentArea.appendChild(section);
      });
    } else {
      // Render type section directly
      const section = createSection(typeId, typeData.label, null);
      contentArea.appendChild(section);
    }
  });
}

function createSection(typeId, sectionLabel, familyId = null) {
  const section = document.createElement('div');
  section.className = 'section';
  section.dataset.sectionType = typeId;
  if (familyId) section.dataset.sectionFamily = familyId;
  
  const heading = document.createElement('h3');
  heading.className = 'section-heading';
  heading.textContent = sectionLabel;
  section.appendChild(heading);
  
  // Get variants
  const typeData = GLOBAL_CATALOG.mainProducts[typeId];
  const variants = familyId
    ? typeData.families[familyId].products
    : typeData.products;
  
  // Create cards container
  const cardsContainer = document.createElement('div');
  if(variants.length > 2 ){
    cardsContainer.className = 'cards-container variants-greater-than-two';
  }else{
    cardsContainer.className = 'cards-container';
  }
  
  variants.forEach(variant => {
    const card = createVariantCard(typeId, familyId, variant);
    cardsContainer.appendChild(card);
  });
  
  section.appendChild(cardsContainer);
  return section;
}

function createVariantCard(typeId, familyId, variant) {
  const card = document.createElement('div');
  card.className = 'variant-card';
  
  const imgContainer = document.createElement('div');
  imgContainer.className = 'card-image-container';
  const img = document.createElement('img');
  img.src = variant.image
  // img.src = 'https://media.istockphoto.com/id/1980276924/vector/no-photo-thumbnail-graphic-element-no-found-or-available-image-in-the-gallery-or-album-flat.jpg?s=612x612&w=0&k=20&c=ZBE3NqfzIeHGDPkyvulUw14SaWfDj2rZtyiKv3toItk=';
  imgContainer.appendChild(img);
  const title = document.createElement('div');
  title.className = 'card-title';
  title.textContent = variant.label;
  card.appendChild(imgContainer);
  card.appendChild(title);
  
  const lengthsList = document.createElement('div');
  lengthsList.className = 'lengths-list';
  lengthsList.dataset.productName = variant.label
  
  variant.lengths.forEach(length => {
    const lengthRow = createLengthRow(typeId, familyId, variant, length);
    lengthsList.appendChild(lengthRow);
  });
  
  card.appendChild(lengthsList);
  return card;
}

function createLengthRow(typeId, familyId, variant, length) {
  const row = document.createElement('div');
  row.className = 'length-row';
  
  // Length value
  const lengthValue = document.createElement('div');
  lengthValue.className = 'length-value';
  if(length.dimensions){
    lengthValue.innerHTML = `${length.value} ${length.unit} <small>${length.dimensions}</small>`;
  }else{
    lengthValue.textContent = `${length.value} ${length.unit}`;
  }
  
  // Price
  priceDiv = document.createElement('div');
  priceDiv.className = 'length-price';
  priceDiv.textContent = formatCurrency(length.price);
  
  // Quantity selector
  const qtySelector = document.createElement('div');
  qtySelector.className = 'quantity-selector';
  
  const minusBtn = document.createElement('button');
  minusBtn.className = 'qty-btn';
  minusBtn.textContent = '−';
  minusBtn.addEventListener('click', () => {
    decrementQuantity(typeId, familyId, variant.id, length.value,length.variantId);
  });
  
  qtyInput = document.createElement('input');
  qtyInput.className = 'qty-input';
  qtyInput.type = 'text';
  qtyInput.value = getMainProductLengthCartQty(typeId,familyId,variant,length) ?? '0';
  qtyInput.readOnly = true;
  qtyInput.dataset.typeId = typeId;
  qtyInput.dataset.familyId = familyId || '';
  qtyInput.dataset.variantId = variant.id;
  qtyInput.dataset.length = length.value;
  qtyInput.dataset.price = length.price;
  
  const plusBtn = document.createElement('button');
  plusBtn.className = 'qty-btn';
  plusBtn.textContent = '+';
  plusBtn.addEventListener('click', () => {
    incrementQuantity(typeId, familyId, variant.id, length.value, length.price,length.variantId);
  });
  
  qtySelector.appendChild(minusBtn);
  qtySelector.appendChild(qtyInput);
  qtySelector.appendChild(plusBtn);
  
  row.appendChild(lengthValue);
  row.appendChild(priceDiv);
  row.appendChild(qtySelector);
  
  return row;
}

function getMainProductLengthCartQty(typeId,familyId,variant,length){
  let cartItem
  if(familyId){
    cartItem = cartState.mainProducts[typeId][familyId][variant.id].find(v => parseInt(v.variantId) == parseInt(length.variantId))
    return cartItem ? cartItem.quantity : '0'
  }else{
    cartItem = cartState.mainProducts[typeId][variant.id].find(v => parseInt(v.variantId) == parseInt(length.variantId))
    return cartItem ? cartItem.quantity : '0'
  }
}

// ======================= QUANTITY MANAGEMENT ======================= //
function incrementQuantity(typeId, familyId, productId, length, price, variantId) {
  const input = document.querySelector(
    `input[data-type-id="${typeId}"][data-variant-id="${productId}"][data-length="${length}"]`
  );
  const currentQty = parseInt(input.value) || 0;
  input.value = currentQty + 1;
  
  // Add to cart
  addToCart(typeId, familyId, productId, variantId, length, price, currentQty + 1, currentQty);
}

function decrementQuantity(typeId, familyId, productId, length, variantId) {
  const input = document.querySelector(
    `input[data-type-id="${typeId}"][data-variant-id="${productId}"][data-length="${length}"]`
  );
  const currentQty = parseInt(input.value) || 0;
  if (currentQty > 0) {
    input.value = currentQty - 1;
    
    // Remove from cart or reduce quantity
    const price = parseFloat(input.dataset.price);
    removeFromCart(typeId, familyId, productId, variantId, length, price, currentQty - 1, currentQty);
  }
}

// ======================= CART MANAGEMENT ======================= //
function addToCart(typeId, familyId, productId, variantId, length, price, newQty, oldQty) {
  const typeData = GLOBAL_CATALOG.mainProducts[typeId];
  let variantData;
  
  if (familyId) {
    variantData = typeData.families[familyId].products.find(v => v.id === productId);
  } else {
    variantData = typeData.products.find(v => v.id === productId);
  }
  
  const existingItem = familyId ? cartState.mainProducts[typeId][familyId][productId].find(item =>
    item.typeId === typeId &&
    item.familyId === familyId &&
    item.productId === productId &&
    item.variantId === variantId &&
    item.length === length
  ) : cartState.mainProducts[typeId][productId].find(item =>
    item.typeId === typeId &&
    item.familyId === familyId &&
    item.productId === productId &&
    item.variantId === variantId &&
    item.length === length
  );
  
  if (existingItem) {
    existingItem.quantity = newQty;
  } else {
    if(familyId){
      cartState.mainProducts[typeId][familyId][[productId]].push({
        typeId,
        typeName: typeData.label,
        familyId,
        familyName: typeData.families[familyId].label,
        productId,
        variantName: variantData.label,
        variantId,
        length,
        lengthUnit: 'mm',
        price,
        quantity: newQty
      });
    }else{
      cartState.mainProducts[typeId][[productId]].push({
        typeId,
        typeName: typeData.label,
        familyId,
        familyName: null,
        productId,
        variantName: variantData.label,
        variantId,
        length,
        lengthUnit: 'mm',
        price,
        quantity: newQty
      });

    }
  }
  
  updateCartDisplay();
  let el = document.getElementById(`cartItemRow__${typeId}__${familyId ? familyId+'__'+productId : productId}__${variantId}`)
  let parent = el.closest('.cart-group')
  if(parent){
    parent.scrollIntoView(
      // {
      //   behavior: 'smooth',
      //   block: 'start',  // or 'end', 'center'
      //   inline: 'nearest'
      // }
    );
  }
}

function removeFromCart(typeId, familyId, productId, variantId, length, price, newQty, oldQty) {
  if (newQty === 0) {
    if(familyId){
      cartState.mainProducts[typeId][familyId][productId] = cartState.mainProducts[typeId][familyId][productId].filter(item =>
        !(item.typeId === typeId &&
          item.familyId === familyId &&
          item.productId === productId &&
          item.variantId === variantId &&
          item.length === length)
      );
    }else{
      cartState.mainProducts[typeId][productId] = cartState.mainProducts[typeId][productId].filter(item =>
        !(item.typeId === typeId &&
          item.familyId === familyId &&
          item.productId === productId &&
          item.variantId === variantId &&
          item.length === length)
      );

    }
  } else {
    // console.log('typeId',typeId);
    // console.log('familyId',familyId);
    // console.log('productId',productId);
    let existingItem
    if(familyId){
      existingItem = cartState.mainProducts[typeId][familyId][productId].find(item =>
        item.typeId === typeId &&
        item.familyId === familyId &&
        item.productId === productId &&
        item.variantId === variantId &&
        item.length === length
      )
    }else{
      existingItem = cartState.mainProducts[typeId][productId].find(item =>
        item.typeId === typeId &&
        item.familyId === familyId &&
        item.productId === productId &&
        item.variantId === variantId &&
        item.length === length
      );
    }
    if (existingItem) {
      existingItem.quantity = newQty;
    }
  }
  
  updateCartDisplay();
}

function addAccessoryToCart(categoryId, productId, productName, variantId, variantTitle, price) {
  const categoryData = GLOBAL_CATALOG.accessories[categoryId];
  const categoryBucket = cartState?.accessories?.[categoryId];
  if (!categoryBucket) return;
  const productBucket = categoryBucket[productId] || (categoryBucket[productId] = {});

  const variantBucket = productBucket[variantId] || (productBucket[variantId] = []);
  const existingItem = variantBucket.find(item =>
    item.categoryId === categoryId &&
    item.productId === productId &&
    item.variantId === variantId
  );
  
  if (existingItem) {
    existingItem.quantity += 1;
  } else {
    variantBucket.push({
      categoryId,
      categoryName: categoryData?.label,
      productId,
      productName,
      variantId,
      variantName: variantTitle,
      price,
      quantity: 1
    });
  }
  
  updateCartDisplay();
  let el = document.getElementById(`cartItemRow__${categoryId}__${productId}__${variantId}`)
  let parent = el.closest('.cart-group')
  if(parent){
    parent.scrollIntoView(
      // {
      //   behavior: 'smooth',
      //   block: 'start',  // or 'end', 'center'
      //   inline: 'nearest'
      // }
    );
  }
  // document.getElementById(`cartItemRow__${categoryId}__${productId}__${variantId}`).scrollIntoView(
    // {
    //   behavior: 'smooth',
    //   block: 'start',  // or 'end', 'center'
    //   inline: 'nearest'
    // }
  // );
}

function removeAccessoryFromCart(categoryId, productId, variantId, newQty) {
  const variantBucket =
    cartState?.accessories?.[categoryId]?.[productId]?.[variantId];
  if (!Array.isArray(variantBucket)) return;

  if (newQty === 0) {
    cartState.accessories[categoryId][productId][variantId] = variantBucket.filter(item =>
      !(item.categoryId === categoryId &&
        item.productId === productId &&
        item.variantId === variantId)
    );
  } else {
    const existingItem = variantBucket.find(item =>
      item.categoryId === categoryId &&
      item.productId === productId &&
      item.variantId === variantId
    );
    if (existingItem) {
      existingItem.quantity = newQty;
    }
  }
  
  updateCartDisplay();
}

// ======================= CART DISPLAY UPDATE ======================= //
function getTotalCartItems(cartState) {
  let total = 0;

  // main products
  Object.values(cartState.mainProducts).forEach(group => {
    if (Array.isArray(group)) {
      total += group.length;
    } else {
      // nested object (angleBars)
      Object.values(group).forEach(arr => {
        if (Array.isArray(arr)) {
          total += arr.length;
        }else{
          Object.values(arr).forEach(arrr => {
            if (Array.isArray(arrr)) {
              total += arrr.length;
            }
          });
        }
      });
    }
  });

  // accessories
  Object.values(cartState.accessories).forEach((categoryObj) => {
    if (Array.isArray(categoryObj)) {
      total += categoryObj.length;
      return;
    }
    if (!categoryObj || typeof categoryObj !== "object") return;

    Object.values(categoryObj).forEach((productObj) => {
      if (!productObj || typeof productObj !== "object") return;
      Object.values(productObj).forEach((variantArr) => {
        if (Array.isArray(variantArr)) {
          total += variantArr.length;
        }
      });
    });
  });

  return total;
}
function updateCartDisplay() {
  const totalItems = getTotalCartItems(cartState);
  const isEmpty = totalItems === 0;

  // console.log(totalItems)
  
  // Update desktop cart
  updateCartPanel(isEmpty);
  
  // Update mobile cart
  updateMobileCart(isEmpty);
}

/* =========================
   HELPERS
   ========================= */

// Human friendly key -> "angleBars" => "Angle Bars"
function formatTitle(key = "") {
  return String(key)
    .replace(/([A-Z])/g, " $1")
    .replace(/_/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/^./, (c) => c.toUpperCase());
}

// Main Products: get product label by ids
function getProductLabelById(cate, subCate = "", prodID) {
  if (!cate || !prodID) return null;

  try {
    if (subCate) {
      const family = GLOBAL_CATALOG?.mainProducts?.[cate]?.families?.[subCate];
      const found = family?.products?.find((p) => String(p.id) === String(prodID));
      return found?.label || null;
    } else {
      const cat = GLOBAL_CATALOG?.mainProducts?.[cate];
      const found = cat?.products?.find((p) => String(p.id) === String(prodID));
      return found?.label || null;
    }
  } catch (e) {
    return null;
  }
}

// Main Products: get price from catalog by length value
function getMainProductPrice({ cate, subCate = "", prodID, lengthValue }) {
  if (!cate || !prodID || lengthValue == null) return null;

  const lv = Number(lengthValue);

  try {
    let prodObj = null;

    if (subCate) {
      prodObj =
        GLOBAL_CATALOG?.mainProducts?.[cate]?.families?.[subCate]?.products?.find(
          (p) => String(p.id) === String(prodID)
        );
    } else {
      prodObj = GLOBAL_CATALOG?.mainProducts?.[cate]?.products?.find(
        (p) => String(p.id) === String(prodID)
      );
    }

    const lenObj = prodObj?.lengths?.find((l) => Number(l.value) === lv);
    // console.log('lenObj',lenObj)
    return typeof lenObj?.price === "number" ? lenObj.price : null;
  } catch (e) {
    return null;
  }
}

// Accessories: get label by accessory product id
function getAccessoryLabelByProductId(accessoryCateKey, accessoryProdId) {
  const products = GLOBAL_CATALOG?.accessories?.[accessoryCateKey]?.products || [];
  const found = products.find((p) => String(p.id) === String(accessoryProdId));
  return found || null;
}

// Accessories: get price by accessory product id
function getAccessoryPriceByProductId(accessoryCateKey, accessoryProdId) {
  const products = GLOBAL_CATALOG?.accessories?.[accessoryCateKey]?.products || [];
  const found = products.find((p) => String(p.id) === String(accessoryProdId));
  return typeof found?.price === "number"
    ? found.price
    : (GLOBAL_CATALOG?.meta?.defaultPrice ?? 0);
}

// Normalize your stored cart array into [{lengthValue, qty}] for main products
// Supports:
// 1) [{ value: 900, qty: 2 }]   (preferred)
// 2) [{ length: 900, quantity: 2 }]
// 3) [900, 900, 1200]           (counts duplicates)
function normalizeMainLineItems(arr) {
  if (!Array.isArray(arr) || arr.length === 0) return [];

  // Case: array of numbers -> count duplicates
  if (typeof arr[0] === "number" || typeof arr[0] === "string") {
    const map = {};
    arr.forEach((v) => {
      const k = Number(v);
      map[k] = (map[k] || 0) + 1;
    });
    return Object.entries(map).map(([lengthValue, qty]) => ({
      lengthValue: Number(lengthValue),
      qty: Number(qty),
    }));
  }

  // Case: array of objects
  return arr
    // .map((x) => {
    //   const lengthValue =
    //     x?.value ?? x?.lengthValue ?? x?.length ?? x?.mm ?? null;
    //   const qty = x?.qty ?? x?.quantity ?? x?.count ?? 1;
    //   return {
    //     lengthValue: lengthValue == null ? null : Number(lengthValue),
    //     qty: Number(qty),
    //   };
    // })
    // .filter((x) => Number.isFinite(x.lengthValue) && x.qty > 0);
}

// Normalize accessories array into [{prodId, qty}]
// Supports:
// 1) [{ id: "acc_fd_alcor", qty: 2 }]
// 2) ["acc_fd_alcor", "acc_fd_alcor"]  (counts)
function normalizeAccessoryLineItems(categoryObj) {
  if (!categoryObj) return [];

  // Legacy: category array
  if (Array.isArray(categoryObj)) {
    if (categoryObj.length === 0) return [];
    if (typeof categoryObj[0] === "string" || typeof categoryObj[0] === "number") {
      const map = {};
      categoryObj.forEach((id) => {
        const k = String(id);
        map[k] = (map[k] || 0) + 1;
      });
      return Object.entries(map).map(([prodId, qty]) => ({ prodId, qty }));
    }
    return categoryObj
      .map((x) => ({
        prodId: String(x?.id ?? x?.prodId ?? ""),
        variantId: String(x?.variantId ?? ""),
        qty: Number(x?.qty ?? x?.quantity ?? 1),
        price: x?.price,
        productName: x?.productName,
        variantName: x?.variantName
      }))
      .filter((x) => x.prodId && x.qty > 0);
  }

  // New structure: category -> product -> variant -> [items]
  const items = [];
  Object.entries(categoryObj).forEach(([prodId, variantsObj]) => {
    if (!variantsObj || typeof variantsObj !== "object") return;
    Object.entries(variantsObj).forEach(([variantId, entries]) => {
      if (!Array.isArray(entries) || entries.length === 0) return;

      const objEntry = entries.find((e) => e && typeof e === "object");
      if (objEntry) {
        const qty = Number(objEntry.quantity ?? objEntry.qty ?? 0);
        if (qty > 0) {
          items.push({
            prodId: String(prodId),
            variantId: String(variantId),
            qty,
            price: objEntry.price,
            productName: objEntry.productName,
            variantName: objEntry.variantName,
            cateId: objEntry.categoryId
          });
        }
        return;
      }

      items.push({
        prodId: String(prodId),
        variantId: String(variantId),
        qty: entries.length
      });
    });
  });

  return items;
}

// Flatten cartState into checkout-friendly product details.
function getCheckoutProductDetails(cart = cartState) {
  const currency = GLOBAL_CATALOG?.meta?.currency ?? "$";
  const defaultPrice = GLOBAL_CATALOG?.meta?.defaultPrice ?? 0;
  const details = [];
  const quantityByVariantId = {};
  const variantIds = []

  const pushDetail = (detail) => {
    const variantId = detail?.variantId == null ? "" : String(detail.variantId);
    const quantity = Number(detail?.quantity ?? 0);
    if (!variantId || !Number.isFinite(quantity) || quantity <= 0) return;

    details.push(detail);
    quantityByVariantId[variantId] = (quantityByVariantId[variantId] || 0) + quantity;
  };

  const pushMainProductDetail = ({ typeId, familyId = "", productId, entry }) => {
    if (!entry || typeof entry !== "object") return;

    const quantity = Number(entry.quantity ?? entry.qty ?? 0);
    const variantId = entry.variantId;
    if (!variantId || !Number.isFinite(quantity) || quantity <= 0) return;

    const length = Number(entry.length ?? entry.lengthValue ?? entry.value);
    const hasLength = Number.isFinite(length);
    const unitPrice =
      typeof entry.price === "number"
        ? entry.price
        : (getMainProductPrice({
            cate: typeId,
            subCate: familyId,
            prodID: productId,
            lengthValue: hasLength ? length : null,
          }) ?? defaultPrice);

    pushDetail({
      source: "mainProducts",
      typeId: String(typeId),
      typeName:
        entry.typeName || GLOBAL_CATALOG?.mainProducts?.[typeId]?.label || null,
      familyId: familyId || null,
      familyName:
        entry.familyName ||
        (familyId
          ? GLOBAL_CATALOG?.mainProducts?.[typeId]?.families?.[familyId]?.label
          : null),
      productId: String(productId),
      productName:
        entry.variantName || getProductLabelById(typeId, familyId, productId) || null,
      variantId: String(variantId),
      length: hasLength ? length : null,
      lengthUnit: entry.lengthUnit || (hasLength ? "mm" : null),
      quantity,
      unitPrice,
      lineTotal: unitPrice * quantity,
    });
  };

  const mainProducts = cart?.mainProducts || {};
  Object.entries(mainProducts).forEach(([typeId, typeBucket]) => {
    if (!typeBucket || typeof typeBucket !== "object") return;

    Object.entries(typeBucket).forEach(([bucketKey, bucketValue]) => {
      if (Array.isArray(bucketValue)) {
        // No-family type: bucketKey is productId and bucketValue is product entries.
        bucketValue.forEach((entry) =>
          pushMainProductDetail({ typeId, familyId: "", productId: bucketKey, entry })
        );
        return;
      }

      if (!bucketValue || typeof bucketValue !== "object") return;
      // Family type: bucketKey is familyId and bucketValue is product map.
      Object.entries(bucketValue).forEach(([productId, entries]) => {
        if (!Array.isArray(entries)) return;
        entries.forEach((entry) =>
          pushMainProductDetail({ typeId, familyId: bucketKey, productId, entry })
        );
      });
    });
  });

  const accessories = cart?.accessories || {};
  Object.entries(accessories).forEach(([categoryId, categoryObj]) => {
    if (!categoryObj || typeof categoryObj !== "object") return;

    Object.entries(categoryObj).forEach(([productId, variantsObj]) => {
      if (!variantsObj || typeof variantsObj !== "object") return;

      Object.entries(variantsObj).forEach(([variantId, entries]) => {
        if (!Array.isArray(entries) || entries.length === 0) return;

        const objEntry = entries.find((x) => x && typeof x === "object");
        const quantity = Number(objEntry?.quantity ?? objEntry?.qty ?? entries.length);
        if (!Number.isFinite(quantity) || quantity <= 0) return;

        const detailsByCatalog = getAccessoryVariantDetailsById(
          categoryId,
          productId,
          variantId
        );
        const productObj = getAccessoryLabelByProductId(categoryId, productId);
        const unitPrice =
          typeof objEntry?.price === "number"
            ? objEntry.price
            : (detailsByCatalog?.price ??
              getAccessoryPriceByProductId(categoryId, productId) ??
              defaultPrice);

        pushDetail({
          source: "accessories",
          categoryId: String(categoryId),
          categoryName:
            objEntry?.categoryName || GLOBAL_CATALOG?.accessories?.[categoryId]?.label || null,
          productId: String(productId),
          productName: objEntry?.productName || productObj?.label || null,
          variantId: String(variantId),
          variantName: objEntry?.variantName || detailsByCatalog?.title || null,
          quantity,
          unitPrice,
          lineTotal: unitPrice * quantity,
        });
      });
    });
  });

  const checkoutItems = Object.entries(quantityByVariantId).map(
    ([variantId, quantity]) => {
      const numericVariantId = Number(variantId);
      variantIds.push(numericVariantId)
      return {
        variant_id: Number.isFinite(numericVariantId) ? numericVariantId : variantId,
        quantity,
      };
    }
  );

  const subtotal = details.reduce((sum, item) => sum + item.lineTotal, 0);
  const totalQuantity = details.reduce((sum, item) => sum + item.quantity, 0);

  return {
    items: details,
    checkoutItems,
    variantIds,
    currency,
    subtotal: Number(subtotal.toFixed(2)),
    totalQuantity,
  };
}
function resetWholeForm() {
  cartState = JSON.parse(JSON.stringify(INITIAL_CART_STATE));

  const firstTypeId = Object.keys(GLOBAL_CATALOG?.mainProducts || {})[0] || null;
  const firstType = firstTypeId ? GLOBAL_CATALOG.mainProducts[firstTypeId] : null;
  const firstFamilyId =
    firstType?.hasFamily ? Object.keys(firstType.families || {})[0] || null : null;
  const firstCategoryId = Object.keys(GLOBAL_CATALOG?.accessories || {})[0] || null;

  currentActiveType = firstTypeId;
  currentActiveFamily = firstFamilyId;
  currentActiveCategory = firstCategoryId;

  document.querySelectorAll(".modal-overlay").forEach((modal) => {
    modal.style.display = "none";
  });

  closeCartDrawer();
  document.body.classList.remove("scroll-locked");
  document.body.classList.remove("mobile-bar-fixed");

  switchTab("mainProducts");
  updateCartDisplay();

  if (firstTypeId) {
    requestAnimationFrame(() => {
      selectProductType(firstTypeId);
      window.scrollController?.refresh();
    });
  }
}
// Simple empty check
function isCartEmpty() {
  // mainProducts
  const mp = cartState?.mainProducts || {};
  for (const cateKey of Object.keys(mp)) {
    const cateObj = mp[cateKey];

    // family-based categories have objects of families
    // non-family have product arrays directly
    if (cateObj && typeof cateObj === "object" && !Array.isArray(cateObj)) {
      // Could be: families OR direct products object (prodId -> [])
      // Detect by: values are objects (families) or arrays (lineitems)
      for (const k of Object.keys(cateObj)) {
        const v = cateObj[k];

        // Family branch: v is object of products -> []
        if (v && typeof v === "object" && !Array.isArray(v)) {
          for (const prodId of Object.keys(v)) {
            if (Array.isArray(v[prodId]) && v[prodId].length > 0) return false;
          }
        }

        // Non-family branch: v is an array
        if (Array.isArray(v) && v.length > 0) return false;
      }
    }
  }

  // accessories
  const acc = cartState?.accessories || {};
  for (const accCateKey of Object.keys(acc)) {
    const categoryObj = acc[accCateKey];
    if (Array.isArray(categoryObj) && categoryObj.length > 0) return false;
    if (!categoryObj || typeof categoryObj !== "object") continue;

    for (const productId of Object.keys(categoryObj)) {
      const variantsObj = categoryObj[productId];
      if (!variantsObj || typeof variantsObj !== "object") continue;
      for (const variantId of Object.keys(variantsObj)) {
        const entries = variantsObj[variantId];
        if (Array.isArray(entries) && entries.length > 0) return false;
      }
    }
  }

  return true;
}

/* =========================
   RENDERER (THE MAIN THING)
   ========================= */

function updateCartPanel(isEmpty) {
  const cartEmpty = document.querySelector(".cart-empty");
  const cartItemsContainer = document.querySelector(".cart-items-container");
  const cartItemsList = document.querySelector(".cart-items-list");
  const cartTotalAmount = document.querySelector(".cart-total-amount");
  const cartCheckout = document.getElementById("checkoutBtn");
  const cartDrawerCheckout = document.getElementById("checkoutBtnDrawer");
  const cartSaveQuote = document.getElementById("saveQuoteBtn");
  const cartDrawerSaveQuote = document.getElementById("saveQuoteBtnDrawer");
  const cartAddToCart = document.getElementById("addToCartBtn");
  const cartDrawerAddToCart = document.getElementById("addToCartBtnDrawer");

  // console.log('cartItemsList',cartItemsList);
  
  if (!cartItemsList) return;

  // console.log('cartItemsList after',cartItemsList);


  if (isEmpty) {
    if (cartEmpty) cartEmpty.style.display = "block";
    if (cartItemsContainer) cartItemsContainer.style.display = "none";
    if (cartTotalAmount) cartTotalAmount.textContent = "$0.00";
    if (cartCheckout) cartCheckout.disabled = true
    if (cartDrawerCheckout) cartDrawerCheckout.disabled = true
    if (cartSaveQuote) cartSaveQuote.disabled = true
    if (cartDrawerSaveQuote) cartDrawerSaveQuote.disabled = true
    if (cartAddToCart) cartAddToCart.disabled = true
    if (cartDrawerAddToCart) cartDrawerAddToCart.disabled = true
    cartItemsList.innerHTML = "";
    return;
  }
  
  if (cartEmpty) cartEmpty.style.display = "none";
  if (cartCheckout) cartCheckout.disabled = false
  if (cartDrawerCheckout) cartDrawerCheckout.disabled = false
  if (cartSaveQuote) cartSaveQuote.disabled = false
  if (cartDrawerSaveQuote) cartDrawerSaveQuote.disabled = false
  if (cartAddToCart) cartAddToCart.disabled = false
  if (cartDrawerAddToCart) cartDrawerAddToCart.disabled = false
  if (cartItemsContainer) cartItemsContainer.style.display = "block";

  // Clear once
  cartItemsList.innerHTML = "";
  // console.log('cartItemsList after clear',cartItemsList);
  const currency = GLOBAL_CATALOG?.meta?.currency ?? "$";
  const defaultPrice = GLOBAL_CATALOG?.meta?.defaultPrice ?? 0;

  let total = 0;

  // Registry ensures we never create duplicate groups in the same render pass
  // sectionKey -> cateKey -> groupKey => itemsContainerElement
  const sectionRegistry = {};
  const groupRegistry = {};

  function getOrCreateSection(sectionKey, sectionLabel) {
    if (sectionRegistry[sectionKey]) return sectionRegistry[sectionKey];

    const section = document.createElement("div");
    section.className = "cart-section";
    section.dataset.key = sectionKey;

    const heading = document.createElement("h1");
    heading.className = "cart-section-heading";
    heading.textContent = sectionLabel;
    section.appendChild(heading);

    cartItemsList.appendChild(section);
    sectionRegistry[sectionKey] = section;
    return section;
  }

  function getOrCreateGroup({ sectionKey, sectionLabel, cateKey, cateLabel, subCate, productLabel }) {
    const key = `${subCate || "none"}|${productLabel}`;

    if (!groupRegistry[sectionKey]) groupRegistry[sectionKey] = {};
    if (groupRegistry[sectionKey][cateKey]){
      if(groupRegistry[sectionKey][cateKey][key]){
        return groupRegistry[sectionKey][cateKey][key];
      }
    }

    const section = getOrCreateSection(sectionKey, sectionLabel);
    let mainGroup = '';
    const cateHeading = document.createElement("h1");
    if (!groupRegistry[sectionKey][cateKey]){
      mainGroup = document.createElement("div");
      mainGroup.className = "cart-cate-group";
      mainGroup.dataset.key = cateKey;

      cateHeading.className = "main-cate-heading";
      cateHeading.textContent = cateLabel ?? formatTitle(cateKey);

      mainGroup.appendChild(cateHeading);
    }else{
      mainGroup = section.querySelector(`.cart-cate-group[data-key="${cateKey}"]`)
    }



    const group = document.createElement("div");
    group.className = "cart-group";
    group.dataset.key = key;

    const header = document.createElement("div");
    header.className = "cart-group-header";

    

    const subCateHeading = document.createElement("h2");
    subCateHeading.className = "sub-cate-heading";

    if (productLabel) {
      if (subCate) {
        subCateHeading.textContent = `${formatTitle(subCate)} • ${productLabel}`;
      } else {
        subCateHeading.textContent = `${productLabel}`;
      }
    } else {
      subCateHeading.textContent = subCate ? formatTitle(subCate) : "";
    }

    if (subCateHeading.textContent) header.appendChild(subCateHeading);

    const itemsContainer = document.createElement("div");
    itemsContainer.className = "cart-group-items";

    group.appendChild(header);
    group.appendChild(itemsContainer);
    mainGroup.appendChild(group)
    section.appendChild(mainGroup);

    if (!groupRegistry[sectionKey][cateKey]) groupRegistry[sectionKey][cateKey] = {};
    groupRegistry[sectionKey][cateKey][key] = itemsContainer;
    return itemsContainer;
  }

  function appendLineItemRow(container, { leftText, rightText }, typeId, familyId = null, productId, length, variantId, price, qty = '0') {
    console.log('typeId',typeId);
    const row = document.createElement("div");
    row.className = "cart-item-row";
    row.id = `cartItemRow__${typeId}__${familyId ? familyId +'__'+productId : productId}__${variantId}`;

    const contentContainer = document.createElement('div')
    contentContainer.className = "cart-item-content-container"

    const qtyContainer = document.createElement('div')
    qtyContainer.className = "cart-item-quantity-selector-container"

    const left = document.createElement("div");
    left.className = "cart-item-left";
    left.innerHTML = leftText;

    const right = document.createElement("div");
    right.className = "cart-item-right";
    right.textContent = rightText;

    // Quantity selector
    const qtySelector = document.createElement('div');
    qtySelector.className = 'quantity-selector';
    
    const minusBtn = document.createElement('button');
    minusBtn.className = 'qty-btn';
    minusBtn.textContent = '−';
    minusBtn.addEventListener('click', () => {
      decrementQuantity(typeId, familyId, productId, length, variantId);
    });
    
    const qtyInput = document.createElement('input');
    qtyInput.className = 'qty-input';
    qtyInput.type = 'text';
    qtyInput.value = qty;
    qtyInput.readOnly = true;
    qtyInput.dataset.typeId = typeId;
    qtyInput.dataset.familyId = familyId || '';
    qtyInput.dataset.variantId = productId;
    qtyInput.dataset.length = length;
    qtyInput.dataset.price = price;
    
    const plusBtn = document.createElement('button');
    plusBtn.className = 'qty-btn';
    plusBtn.textContent = '+';
    plusBtn.addEventListener('click', () => {
      incrementQuantity(typeId, familyId, productId, length, price, variantId);
    });
    
    qtySelector.appendChild(minusBtn);
    qtySelector.appendChild(qtyInput);
    qtySelector.appendChild(plusBtn);

    contentContainer.appendChild(left);
    contentContainer.appendChild(right);
    qtyContainer.appendChild(qtySelector)
    row.appendChild(contentContainer)
    row.appendChild(qtyContainer)
    container.appendChild(row);
  }
  function appendAccessoriesLineItemRow(container, { leftText, rightText }, typeId, productId, variantId, price, qty = '0',prodObj) {
    const row = document.createElement("div");
    row.className = "cart-item-row";
    row.id = `cartItemRow__${typeId}__${productId}__${variantId}`;

    const contentContainer = document.createElement('div')
    contentContainer.className = "cart-item-content-container"

    const qtyContainer = document.createElement('div')
    qtyContainer.className = "cart-item-quantity-selector-container"

    const left = document.createElement("div");
    left.className = "cart-item-left";
    left.innerHTML = leftText;

    const right = document.createElement("div");
    right.className = "cart-item-right";
    right.textContent = rightText;

    // Quantity selector
    const qtySelector = document.createElement('div');
    qtySelector.className = 'quantity-selector';
    
    const minusBtn = document.createElement('button');
    minusBtn.className = 'qty-btn';
    minusBtn.textContent = '−';
    minusBtn.addEventListener('click', () => {
      const variantData = getSelectedVariantData(prodObj,null,variantId);
      if (!variantData) {
        alert("This variant combination is not available. Please select a different option.");
        return;
      }
      decrementAccessoryQuantity(typeId, productId, variantData.variantId);
      // decrementQuantity(typeId, familyId, productId, length, variantId);
    });
    
    const qtyInput = document.createElement('input');
    qtyInput.className = 'qty-input';
    qtyInput.type = 'text';
    qtyInput.value = qty;
    qtyInput.readOnly = true;
    qtyInput.dataset.categoryId = typeId;
    qtyInput.dataset.productId = productId;
    qtyInput.dataset.variantId = variantId;
    qtyInput.dataset.price = price;
    
    const plusBtn = document.createElement('button');
    plusBtn.className = 'qty-btn';
    plusBtn.textContent = '+';
    plusBtn.addEventListener('click', () => {
      const variantData = getSelectedVariantData(prodObj,null,variantId);
      if (!variantData) {
        alert("This variant combination is not available. Please select a different option.");
        return;
      }
      incrementAccessoryQuantity(
        typeId,
        productId,
        prodObj.label,
        variantData.variantId,
        variantData.variantTitle,
        variantData.price
      );
      // incrementQuantity(typeId, familyId, productId, length, price, variantId);
    });
    
    qtySelector.appendChild(minusBtn);
    qtySelector.appendChild(qtyInput);
    qtySelector.appendChild(plusBtn);

    contentContainer.appendChild(left);
    contentContainer.appendChild(right);
    qtyContainer.appendChild(qtySelector)
    row.appendChild(contentContainer)
    row.appendChild(qtyContainer)
    container.appendChild(row);
  }

  /* =========================
     MAIN PRODUCTS RENDER
     ========================= */

  const mp = cartState?.mainProducts || {};

  // Iterate categories
  for (const cateKey of Object.keys(mp)) {
    const cateObj = mp[cateKey];
    if (!cateObj || typeof cateObj !== "object") continue;

    // Two shapes:
    // 1) Family-based: cateObj[subCateKey][prodId] => []
    // 2) Non-family:  cateObj[prodId] => []
    //
    // We'll detect: if any value inside cateObj is an object (not array),
    // treat as families.

    const topValues = Object.values(cateObj);
    const looksLikeFamilies = topValues.some(
      (v) => v && typeof v === "object" && !Array.isArray(v)
    );

    if (looksLikeFamilies) {
      // FAMILY MODE
      for (const subCateKey of Object.keys(cateObj)) {
        const productsMap = cateObj[subCateKey];
        if (!productsMap || typeof productsMap !== "object") continue;

        for (const prodId of Object.keys(productsMap)) {
          const linesArr = productsMap[prodId];
          const lineItems = normalizeMainLineItems(linesArr);
          // console.log(lineItems)
          if (!lineItems.length) continue;
          lineItems.sort((a, b) => a.length - b.length);
          const productLabel =
            getProductLabelById(cateKey, subCateKey, prodId) || String(prodId);

          const groupContainer = getOrCreateGroup({
            sectionKey: "mainProducts",
            sectionLabel: "Lintels & T-Bars",
            cateKey,
            subCate: subCateKey,
            productLabel,
          });

          // Render each length row
          lineItems.forEach(({ typeId, familyId, productId, length, quantity, variantId, price}) => {
            const itemPrice =
              getMainProductPrice({
                cate: cateKey,
                subCate: subCateKey,
                prodID: prodId,
                lengthValue: length,
              }) ?? defaultPrice;

            total += itemPrice * quantity;

            appendLineItemRow(groupContainer, {
              leftText: `<b>${quantity}</b> x ${length}mm`,
              rightText: formatCurrency(itemPrice * quantity)
              // `${currency}${().toFixed(2)}`,
            }, typeId, familyId, productId, length, variantId, price, quantity);
          });
        }
      }
    } else {
      // NON-FAMILY MODE
      for (const prodId of Object.keys(cateObj)) {
        const linesArr = cateObj[prodId];
        const lineItems = normalizeMainLineItems(linesArr);
        if (!lineItems.length) continue;

        const productLabel = getProductLabelById(cateKey, "", prodId) || String(prodId);

        const groupContainer = getOrCreateGroup({
          sectionKey: "mainProducts",
          sectionLabel: "Lintels & T-Bars",
          cateKey,
          subCate: "",
          productLabel,
        });

        lineItems.forEach(({ typeId, familyId, productId, length, quantity, variantId, price }) => {
          const itemPrice =
            getMainProductPrice({
              cate: cateKey,
              subCate: "",
              prodID: prodId,
              lengthValue: length,
            }) ?? defaultPrice;

          total += itemPrice * quantity;

          appendLineItemRow(groupContainer, {
            leftText: `<b>${quantity}</b> x ${length}mm`,
            rightText: formatCurrency(itemPrice * quantity)
            // `${currency}${(itemPrice * quantity).toFixed(2)}`,
          }, typeId, familyId, productId, length, variantId, price, quantity);
        });
      }
    }
  }

  /* =========================
     ACCESSORIES RENDER
     ========================= */

  const acc = cartState?.accessories || {};
  for (const accCateKey of Object.keys(acc)) {
    const categoryObj = acc[accCateKey];
    const items = normalizeAccessoryLineItems(categoryObj);
    // console.log('categoryObj',categoryObj)
    // console.log('items',items)
    if (!items.length) continue;

    // For accessories, group by accessory category + product label
    // (subCate empty; category is "Accessories" but you can also use the actual key)
    items.forEach(({ cateId,prodId, variantId, qty, price, variantName }) => {
      let prodObj = getAccessoryLabelByProductId(accCateKey, prodId)
      const productLabel = prodObj ?  prodObj.label : String(prodId);

      const groupContainer = getOrCreateGroup({
        sectionKey: "accessories",
        sectionLabel: "Accessories",
        cateKey: accCateKey,
        cateLabel: GLOBAL_CATALOG?.accessories?.[accCateKey]?.label,
        subCate: "",
        productLabel,
      });

      const details = variantId
        ? getAccessoryVariantDetailsById(accCateKey, prodId, variantId)
        : null;
      const unitPrice =
        typeof price === "number"
          ? price
          : (details?.price ?? getAccessoryPriceByProductId(accCateKey, prodId) ?? defaultPrice);
      const label = variantName || details?.title;

      total += unitPrice * qty;

      appendAccessoriesLineItemRow(groupContainer, {
        leftText: label ? `<b>${qty}</b> x ${label}` : `Qty x ${qty}`,
        rightText: formatCurrency(unitPrice * qty)
        // `${currency}${(unitPrice * qty).toFixed(2)}`,
      },cateId, prodId, variantId, price, qty,prodObj);
    });
  }

  /* =========================
     TOTAL
     ========================= */
  if (cartTotalAmount) {
    cartTotalAmount.textContent = formatCurrency(total)
    // `${currency}${total.toFixed(2)}`;
  }
}
// ======================= ACCESSORIES SCREEN RENDERING ======================= //
function renderAccessoriesScreen() {
  const contentArea = document.querySelector('.categories-content');
  const categoryBarContainer = document.querySelector('.category-bar-container');
  
  contentArea.innerHTML = '';
  categoryBarContainer.innerHTML = '';
  
  const categoryIds = Object.keys(GLOBAL_CATALOG.accessories);
  
  // Render category buttons
  categoryIds.forEach((categoryId, index) => {
    const category = GLOBAL_CATALOG.accessories[categoryId];
    const button = document.createElement('button');
    button.className = 'category-button';
    if (index === 0) button.classList.add('active');
    button.dataset.category = categoryId;
    button.textContent = category.label;
    
    button.addEventListener('click', () => {
      selectCategory(categoryId);
    });
    
    categoryBarContainer.appendChild(button);
  });
  
  // Render category sections
  categoryIds.forEach(categoryId => {
    const category = GLOBAL_CATALOG.accessories[categoryId];
    const section = document.createElement('div');
    section.className = 'section';
    section.dataset.sectionCategory = categoryId;
    
    const heading = document.createElement('h3');
    heading.className = 'section-heading';
    heading.textContent = category.label;
    section.appendChild(heading);
    
    const cardsContainer = document.createElement('div');
    cardsContainer.className = 'cards-container accessories-card-container';
    
    category.products.forEach(product => {
      const card = createAccessoryCard(categoryId, product);
      cardsContainer.appendChild(card);
    });
    
    section.appendChild(cardsContainer);
    contentArea.appendChild(section);
  });
}
function getFirstVariantPrice(product){
  if(product.hasVariants){
    return product.variants[Object.keys(product.variants)[0]].price
  }else{
    return product.price
  }
}
function getAccessoryVariantDetailsById(categoryId, productId, variantId) {
  const products = GLOBAL_CATALOG?.accessories?.[categoryId]?.products || [];
  const product = products.find((p) => String(p.id) === String(productId));
  if (!product) return null;

  if (product.hasVariants) {
    const variants = product.variants || {};
    const found = Object.values(variants).find(
      (v) => String(v.id) === String(variantId)
    );
    return found ? { title: found.title, price: found.price } : null;
  }

  return {
    title: product.label,
    price: typeof product.price === "number" ? product.price : null,
  };
}

function getAccessoryVariantQuantity(categoryId, productId, variantId) {
  const entries =
    cartState?.accessories?.[categoryId]?.[productId]?.[variantId];
  if (!Array.isArray(entries) || entries.length === 0) return 0;

  const objEntry = entries.find((e) => e && typeof e === "object");
  if (objEntry && typeof objEntry.quantity === "number") {
    return objEntry.quantity;
  }

  return entries.length;
}
const buildVariantKey = (product,variantArea) => {
  if (!product.hasVariants) return null;
  const selections = product.variantOptions.map((opt) => {
    const sel = variantArea.querySelector(`select[data-option-key="${opt}"]`);
    return sel ? sel.value : '';
  });
  return selections.join('|');
};
const buildVariantKeyByVariantId = (product,variantId) => {
  if (!product.hasVariants) return null;
  const selections = Object.entries(product.variants).find(([key,opt]) => {
    return parseInt(opt.id) == parseInt(variantId);
  });
  return selections;
};

const getSelectedVariantData = (product,variantArea = null,variantId) => {
  if (!product.hasVariants) {
    const fallbackVariantId = product.variantId ?? product.id;
    return {
      variantKey: null,
      variantId: fallbackVariantId,
      variantTitle: product.label,
      price: product.price,
      image: product.image ?? 'https://media.istockphoto.com/id/1980276924/vector/no-photo-thumbnail-graphic-element-no-found-or-available-image-in-the-gallery-or-album-flat.jpg?s=612x612&w=0&k=20&c=ZBE3NqfzIeHGDPkyvulUw14SaWfDj2rZtyiKv3toItk='
    };
  }

  const key = variantArea ? buildVariantKey(product,variantArea) : buildVariantKeyByVariantId(product,variantId)[0];
  const variant = product.variants?.[key];
  if (!variant) return null;
  return {
    variantKey: key,
    variantId: variant.id,
    variantTitle: variant.title,
    price: variant.price,
    image: variant.image ?? ''
  };
};
function createAccessoryCard(categoryId, product) {
  const card = document.createElement('div');
  card.className = 'accessory-card';
  
  const imgContainer = document.createElement('div');
  imgContainer.className = 'card-image-container';
  let img = document.createElement('img');
  if(product.image){
    img.src = product.image;
  }else if(product.hasVariants){
    img.src = Object.entries(product.variants)[0][1].image
  }else{
    img.src = 'https://media.istockphoto.com/id/1980276924/vector/no-photo-thumbnail-graphic-element-no-found-or-available-image-in-the-gallery-or-album-flat.jpg?s=612x612&w=0&k=20&c=ZBE3NqfzIeHGDPkyvulUw14SaWfDj2rZtyiKv3toItk=';
  }
  imgContainer.appendChild(img);
  const title = document.createElement('div');
  title.className = 'card-title';
  title.textContent = product.label;
  card.appendChild(imgContainer);
  card.appendChild(title);
  
  const variantArea = document.createElement('div');
  variantArea.className = 'variant-area'

  let priceDiv = null;
  let qtyInput = null;
  const applyVariantData = (variantData) => {
    if (!variantData || !priceDiv || !qtyInput || !img) return;
    priceDiv.textContent = `$${variantData.price.toFixed(2)}`;
    qtyInput.value = String(
      getAccessoryVariantQuantity(categoryId, product.id, variantData.variantId)
    );
    qtyInput.dataset.variantId = variantData.variantId;
    qtyInput.dataset.price = variantData.price;
    qtyInput.dataset.variantTitle = variantData.variantTitle;
    if(variantData?.image){
      img.src = variantData.image
    }
  };
  if(product.hasVariants){
    Object.keys(product.optionValues).forEach(v => {
      let variantSelectContainer = document.createElement('div')
      variantSelectContainer.className = "acc-variant-dropdown-container"
      variantSelectContainer.id = `acc__${v}__variant-dropdown-container`

      let variantSelectLabel = document.createElement('label')
      variantSelectLabel.textContent = formatTitle(v)
      variantSelectLabel.htmlFor = `acc__${v}__options-select`

      let variantSelect = document.createElement('select')
      variantSelect.className = "acc-variant-dropdown"
      variantSelect.id = `acc__${v}__options-select`
      variantSelect.dataset.optionKey = v

      product.optionValues[v].forEach(vv => {
        let variantSelectOption = document.createElement('option')
        variantSelectOption.value = vv
        variantSelectOption.textContent = vv
        variantSelect.appendChild(variantSelectOption)
      })
      let previousValue = variantSelect.value;
      variantSelect.addEventListener("change", (e) => {
        const selectEl = e.target;


        const variantData = getSelectedVariantData(product,variantArea);
        if (!variantData) {
          alert("This variant combination is not available. Please select a different option.");
          selectEl.value = previousValue;
          return;
        }

        previousValue = selectEl.value;
        applyVariantData(variantData);
      });
      variantSelectContainer.appendChild(variantSelectLabel)
      variantSelectContainer.appendChild(variantSelect)
      variantArea.appendChild(variantSelectContainer)
    })
  }

  const row = document.createElement('div');
  row.className = 'length-row';
  
  priceDiv = document.createElement('div');
  priceDiv.className = 'length-price';
  priceDiv.textContent = formatCurrency(getFirstVariantPrice(product))
  // `$${getFirstVariantPrice(product).toFixed(2)}`;
  // priceDiv.textContent = `$10`;
  
  const qtySelector = document.createElement('div');
  qtySelector.className = 'quantity-selector';
  
  const minusBtn = document.createElement('button');
  minusBtn.className = 'qty-btn';
  minusBtn.textContent = '−';
  minusBtn.addEventListener('click', () => {
    const variantData = getSelectedVariantData(product,variantArea);
    if (!variantData) {
      alert("This variant combination is not available. Please select a different option.");
      return;
    }
    decrementAccessoryQuantity(categoryId, product.id, variantData.variantId);
  });
  
  qtyInput = document.createElement('input');
  qtyInput.className = 'qty-input';
  qtyInput.type = 'text';
  qtyInput.value = '0';
  qtyInput.readOnly = true;
  qtyInput.dataset.categoryId = categoryId;
  qtyInput.dataset.productId = product.id;
  qtyInput.dataset.price = product.price;
  
  const plusBtn = document.createElement('button');
  plusBtn.className = 'qty-btn';
  plusBtn.textContent = '+';
  plusBtn.addEventListener('click', () => {
    const variantData = getSelectedVariantData(product,variantArea);
    if (!variantData) {
      alert("This variant combination is not available. Please select a different option.");
      return;
    }
    incrementAccessoryQuantity(
      categoryId,
      product.id,
      product.label,
      variantData.variantId,
      variantData.variantTitle,
      variantData.price
    );
  });
  
  qtySelector.appendChild(minusBtn);
  qtySelector.appendChild(qtyInput);
  qtySelector.appendChild(plusBtn);
  
  row.appendChild(priceDiv);
  row.appendChild(qtySelector);
  card.appendChild(variantArea)
  card.appendChild(row);
  applyVariantData(getSelectedVariantData(product,variantArea));
  return card;
}

function selectCategory(categoryId) {
  currentActiveCategory = categoryId;
  // document.querySelectorAll('.category-button').forEach(btn => {
  //   btn.classList.remove('active');
  // });
  // const categoryBtn = document.querySelector(`[data-category="${categoryId}"]`);
  // if (categoryBtn) categoryBtn.classList.add('active');
  
  setTimeout(() => {
    scrollToSection(null, null, categoryId);
  }, 50);
}

function initializeAccessoriesButtons() {
  const categoryButtons = document.querySelectorAll('.category-button');
  
  categoryButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      const categoryId = e.target.dataset.category;
      selectCategory(categoryId);
    });
  });
}

function incrementAccessoryQuantity(categoryId, productId, productName, variantId, variantTitle, price) {
  const input = document.querySelector(
    `input[data-category-id="${categoryId}"][data-product-id="${productId}"][data-variant-id="${variantId}"]`
  );
  // console.log('input',input);
  const currentQty = parseInt(input.value) || 0;
  input.value = currentQty + 1;
  addAccessoryToCart(categoryId, productId, productName, variantId, variantTitle, price);
}

function decrementAccessoryQuantity(categoryId, productId, variantId) {
  const input = document.querySelector(
    `input[data-category-id="${categoryId}"][data-product-id="${productId}"][data-variant-id="${variantId}"]`
  );
  const currentQty = parseInt(input.value) || 0;
  if (currentQty > 0) {
    input.value = currentQty - 1;
    removeAccessoryFromCart(categoryId, productId, variantId, currentQty - 1);
  }
}

// ======================= SCROLL TO SECTION ======================= //

function scrollContainerToElement(container, element, offset = 0) {
  // element position relative to viewport
  const elRect = element.getBoundingClientRect();
  const cRect = container.getBoundingClientRect();

  // element position inside container scroll space
  const y = (elRect.top - cRect.top) + container.scrollTop - offset;

  container.scrollTo({ top: y, behavior: "smooth" });
}

function scrollToSection(typeId, familyId, categoryId) {
  const isDesktop = () =>
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  
  let element = null;
  // console.log('typeId',typeId)
  // console.log('familyId',familyId)
  // console.log('categoryId',categoryId)
  if (categoryId) {
    element = document.querySelector(`[data-section-category="${categoryId}"]`);
  } else {
    if (familyId) {
      element = document.querySelector(`[data-section-type="${typeId}"][data-section-family="${familyId}"]`);
    } else {
      element = document.querySelector(`[data-section-type="${typeId}"]:not([data-section-family])`);
    }
  }
  
  // console.log('element',element)
  if (element) {
    const container = categoryId 
      ? document.querySelector('.categories-content')
      : document.querySelector('.products-content');
    
    if (container) {
      const elementTop = element.offsetTop;
      const offset = window.innerWidth > 1450 ? familyId ? 400 : 340 : familyId ? 460 : 400 // Small offset from top
      const mobileOffset = familyId ? 160 : 130
      // ✅ Mobile/tablet: keep default browser behavior
      // requestAnimationFrame(() => {
      //   requestAnimationFrame(() => {
          if (!isDesktop()) {
            // console.log('is mobile')
            window.scrollTo({
              top: elementTop - mobileOffset,
              behavior: 'smooth'
            });
            // scrollContainerToElement(container, element, offset);
          }else{
            scrollUntilHeaderHidden()
            window.scrollController.scrollTo(elementTop - offset);
          }
      //   })
      // })
    }
  }
}

// ======================= SCROLL SPY (NEW - CONTAINER-BASED) ======================= //
// FIXED: Uses container.scrollTop and section.offsetTop for proper scroll detection
// This correctly identifies which section is currently visible below sticky bars
let scrollSpyTimeout;
let spyRaf = null;
let performScrollSpy;

function setupScrollSpy() {
  const productsContent = document.querySelector('.products-content');
  const categoriesContent = document.querySelector('.categories-content');

  const isDesktop = () =>
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  performScrollSpy = function () {
    const activeScreen = document.querySelector(
      '.app-container [data-screen]:not([style*="display: none"])'
    );
    if (!activeScreen) return;

    if (activeScreen.dataset.screen === 'mainProducts') {
      const sections = document.querySelectorAll('.app-container [data-section-type]');
      scrollSpyUpdateButtons(productsContent, sections, isDesktop());
    } else if (activeScreen.dataset.screen === 'accessories') {
      const sections = document.querySelectorAll('[data-section-category]');
      scrollSpyUpdateCategoryButtons(categoriesContent, sections, isDesktop());
    }
  };

  const throttledScrollSpy = () => {
    if (spyRaf) return;
    spyRaf = requestAnimationFrame(() => {
      spyRaf = null;
      performScrollSpy();
    });
  };

  // Desktop: inner scroll containers
  productsContent?.addEventListener('scroll', throttledScrollSpy);
  categoriesContent?.addEventListener('scroll', throttledScrollSpy);

  // ✅ Mobile: window scroll (because there's no inner container scroll)
  if (!isDesktop()) {
    window.addEventListener('scroll', throttledScrollSpy, { passive: true });
  }
}

function scrollSpyUpdateButtons(container, sections,isDesktop) {
  // console.log('isDesktoppppppp',isDesktop)
  const scrollTop = isDesktop ? container.scrollTop : window.scrollY;
  const triggerPoint = isDesktop ? scrollTop + 80 : scrollTop - 800; // Offset for sticky bars
  //   console.log('scrollTop',scrollTop);
  //   console.log('triggerPoint',triggerPoint);
  let closestSection = null;
  let closestDistance = Infinity;
  
  // Find the section whose top is closest to the trigger point
  sections.forEach(section => {
    const sectionTop = isDesktop ? section.offsetTop : section.getBoundingClientRect().top + window.scrollY;
    const distance = Math.abs(sectionTop - triggerPoint);
    
    // Prefer sections that are below the trigger point (positive offset)
    const adjustedDistance = sectionTop >= triggerPoint ? distance : distance + 500;
    
    if (adjustedDistance < closestDistance) {
      closestDistance = adjustedDistance;
      closestSection = section;
    }
  });
  
  if (!closestSection && sections.length > 0) {
    closestSection = sections[0];
  }
  
  if (closestSection) {
    const typeId = closestSection.dataset.sectionType;
    const familyId = closestSection.dataset.sectionFamily;
    
    // Update type button
    document.querySelectorAll('.type-button').forEach(btn => {
      btn.classList.remove('active');
    });
    const typeBtn = document.querySelector(`[data-type="${typeId}"]`);
    if (typeBtn) typeBtn.classList.add('active');
    let p = typeBtn.closest('.type-bar')
    p.scrollTo({
      left: typeBtn.offsetLeft - p.offsetLeft,
      behavior: 'smooth'
    })
    currentActiveType = typeId;
    
    // Update family button if applicable
    const familyBar = document.querySelector('.family-bar');
    if (familyId) {
        familyBar.style.display = 'block'
      document.querySelectorAll('.family-button').forEach(btn => {
        btn.classList.remove('active');
      });
      const familyBtn = document.querySelector(`[data-family="${familyId}"]`);
      if (familyBtn) familyBtn.classList.add('active');
      let fp = familyBtn.closest('.family-bar')
      fp.scrollTo({
        left: familyBtn.offsetLeft - fp.offsetLeft,
        behavior: 'smooth'
      })
      currentActiveFamily = familyId;
    }else{
        familyBar.style.display = 'none'
    }
  }
}

function scrollSpyUpdateCategoryButtons(container, sections,isDesktop) {
  const scrollTop = isDesktop ? container.scrollTop : window.scrollY;

  const triggerPoint = isDesktop ? scrollTop + 80 : scrollTop - 700; // Offset for sticky bars
  
  let closestSection = null;
  let closestDistance = Infinity;
  
  // Find the section whose top is closest to the trigger point
  sections.forEach(section => {
    const sectionTop = isDesktop ? section.offsetTop : section.getBoundingClientRect().top + window.scrollY;
    const distance = Math.abs(sectionTop - triggerPoint);
    
    // Prefer sections that are below the trigger point (positive offset)
    const adjustedDistance = sectionTop >= triggerPoint ? distance : distance + 500;
    
    if (adjustedDistance < closestDistance) {
      closestDistance = adjustedDistance;
      closestSection = section;
    }
  });
  
  if (!closestSection && sections.length > 0) {
    closestSection = sections[0];
  }
  
  if (closestSection) {
    const categoryId = closestSection.dataset.sectionCategory;
    
    // Update category button
    document.querySelectorAll('.category-button').forEach(btn => {
      btn.classList.remove('active');
    });
    const categoryBtn = document.querySelector(`[data-category="${categoryId}"]`);
    if (categoryBtn) categoryBtn.classList.add('active');
    let cp = categoryBtn.closest('.category-bar')
    cp.scrollTo({
      left: categoryBtn.offsetLeft - cp.offsetLeft,
      behavior: 'smooth'
    })
    currentActiveCategory = categoryId;
  }
}

// ======================= CART HANDLERS ======================= //
function initializeCartHandlers() {
  const checkoutBtn = document.getElementById('checkoutBtn');
  const saveQuoteBtn = document.getElementById('saveQuoteBtn');
  const addToCartBtn = document.getElementById('addToCartBtn');
  const checkoutBtnDrawer = document.getElementById('checkoutBtnDrawer');
  const saveQuoteBtnDrawer = document.getElementById('saveQuoteBtnDrawer');
  const addToCartBtnDrawer = document.getElementById('addToCartBtnDrawer');
  const checkoutModalProceedBtn = document.getElementById('checkoutModalProceedBtn');
  const saveQuoteModalProceedBtn = document.getElementById('saveQuoteModalProceedBtn');
  
  checkoutBtn.addEventListener('click', () => openModal('checkoutModal'));
  saveQuoteBtn.addEventListener('click', () => openModal('saveQuoteModal'));
  addToCartBtn.addEventListener('click', () => addToCartFunc());
  checkoutBtnDrawer.addEventListener('click', () => openModal('checkoutModal'));
  saveQuoteBtnDrawer.addEventListener('click', () => openModal('saveQuoteModal'));
  addToCartBtnDrawer.addEventListener('click', () => addToCartFunc());
  checkoutModalProceedBtn.addEventListener('click', () => validateAndSubmitCheckout());
  saveQuoteModalProceedBtn.addEventListener('click', () => validateAndSubmitSave());
}

// ======================= MODAL HANDLERS ======================= //
function initializeModalHandlers() {
  const modals = document.querySelectorAll('.lintels-modal-overlay');
  
  modals.forEach(modal => {
    const closeButtons = modal.querySelectorAll('[data-modal]');
    closeButtons.forEach(button => {
      button.addEventListener('click', () => {
        closeModal(button.dataset.modal);
      });
    });
    
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        closeModal(modal.id);
      }
    });
  });
}

function openModal(modalId) {
  let cartTotal = getTotalCartItems(cartState)
  if(cartTotal === 0) return
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.style.display = 'flex';
  }
}

function closeModal(modalId) {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.style.display = 'none';
  }
}

async function addToCartFunc(){
  let cartTotal = getTotalCartItems(cartState)
  if(cartTotal === 0) return

  const lineitemsObject = getCheckoutProductDetails();
  let lineitems = lineitemsObject.checkoutItems
  // console.log(lineitemsObject); // send this to checkout API

  let cartObject = await getCartItemsObject()
  let cartObjectKeys = Object.keys(cartObject)
  cartObjectKeys = cartObjectKeys.length > 0 ? cartObjectKeys.map(v => parseInt(v)) : []

  let updates = {};
  if(lineitems.length > 0){
    lineitems.forEach(item => {
      if(cartObjectKeys.includes(parseInt(item.variant_id))){
        updates[parseInt(item.variant_id)] = item.quantity + cartObject[parseInt(item.variant_id)]
      }else{
        updates[parseInt(item.variant_id)] = item.quantity
      }
    });
    // console.log('formattedCartObject',updates)

    if(Object.keys(updates).length > 0){
      jQuery('.mainloaderContainer').fadeIn(500)
      jQuery('.mainloaderContainer p').text('Adding Items to Cart...')
      jQuery('html,.products-content,.categories-content').css('overflow','hidden')
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      })
      .then(response => response.json())
      .then(data => {
        // console.log(data); // cart JSON
        jQuery('.mainloaderContainer').fadeOut(500)
        jQuery('html').css('overflow','auto')
        jQuery('.products-content,.categories-content').attr('style','')
        if(data?.status && data?.status == 422){
          alert('We encountered an issue while adding the products to your cart. Please try again, or contact support if the problem persists.')
        }else{
          resetWholeForm()
          window.location.href = window.location.origin
        }
      })
      .catch((error) => {
        jQuery('.mainloaderContainer').fadeOut(500)
        jQuery('html').css('overflow','auto')
        jQuery('.products-content,.categories-content').attr('style','')
        alert('Something went wrong while adding to cart, try again or contact support')
        console.error('Error:', error);
      });
    }
  }
}
async function createDraftOrder(payload, onSuccess, onError) {
  try {
    // console.log(payload)
    // return
    // 1) Create draft order
    // const draftRes = await fetch("https://0d708064d622.ngrok-free.app/api/draft-order", {
    const draftRes = await fetch("https://buda-backend.vercel.app/api/draft-order", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    if (!draftRes.ok) {
      throw new Error("Network error while creating draft order");
    }

    const res = await draftRes.json();

    if (!res.success) {
      throw new Error(res.error || "Error creating draft order");
    }

    // ✅ Everything succeeded – call your function
    if (typeof onSuccess === "function") {
      onSuccess(res);
    }

  } catch (err) {
    console.error("Request error:", err);
    if (typeof onError === "function") {
      onError(err);
    }
  }
}
async function createSaveDraftOrder(payload, onSuccess, onError) {
  try {
    // console.log(payload)
    // return
    // 1) Create draft order
    // const draftRes = await fetch("https://0d5f60bf149e.ngrok-free.app/api/save-draft-order", {
    const draftRes = await fetch("https://buda-backend.vercel.app/api/save-draft-order", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    if (!draftRes.ok) {
      throw new Error("Network error while creating draft order");
    }

    const res = await draftRes.json();

    if (!res.success) {
      throw new Error(res.error || "Error creating draft order");
    }

    // ✅ Everything succeeded – call your function
    if (typeof onSuccess === "function") {
      onSuccess(res);
    }

  } catch (err) {
    console.error("Request error:", err);
    if (typeof onError === "function") {
      onError(err);
    }
  }
}
async function validateAndSubmitCheckout(){
  let cartTotal = getTotalCartItems(cartState)
  if(cartTotal === 0) return
  if (!validateCheckoutModal()) {
    return;
  }
  const lineitems = getCheckoutProductDetails();
  // console.log(lineitems); // send this to checkout API

  let cartObject = await getCartItemsObject()
  let cartObjectKeys = Object.keys(cartObject)
  cartObjectKeys = cartObjectKeys.length > 0 ? cartObjectKeys.map(v => parseInt(v)) : []

  // if(!cartObjectKeys.length) return

  lineitems.checkoutItems.forEach(item => {
    if(cartObjectKeys.includes(parseInt(item.variant_id))){
      item.quantity = item.quantity + cartObject[parseInt(item.variant_id)]
    }
  });
  cartObjectKeys.forEach(key => {
    if(!lineitems.variantIds.includes(key)){
      lineitems.checkoutItems.push(
        {
          variant_id: parseInt(key),
          quantity: cartObject[parseInt(key)]
        }
      )
    }
  });

  const header = document.querySelector("#checkoutModal .lintels-modal-header");
  const form = document.querySelector("#checkoutModal .lintels-modal-body");
  const footer = document.querySelector("#checkoutModal .lintels-modal-footer");
  const loader = document.getElementById("checkout-loader");

  header.style.display = "none";
  form.style.display = "none";
  footer.style.display = "none";
  loader.style.display = "flex";

  const formData = {
    firstName: document.getElementById("firstName").value.trim(),
    lastName: document.getElementById("lastName").value.trim(),
    companyName: document.getElementById("companyName").value.trim(),
    email: document.getElementById("email").value.trim(),
    phone: document.getElementById("phone").value.trim(),
  };

  let shipping_address = {};
  if (formData.firstName) shipping_address.first_name = formData.firstName;
  if (formData.lastName) shipping_address.last_name = formData.lastName;
  if (formData.companyName) shipping_address.company = formData.companyName;
  if (formData.phone) shipping_address.phone = formData.phone;
  shipping_address.country = 'Australia'

  let payload = {
      email: formData.email,
      note: "Customized Lintels Order",
      line_items:lineitems.checkoutItems,
  }

  Object.keys(shipping_address).length > 0 ? payload.shipping_address = shipping_address : '';

  createDraftOrder(payload,async function(res){
    await clearCart()
    setTimeout(() => {
      res.draft_order.invoice_url ? window.location.href = res.draft_order.invoice_url : '';
    },1000)
  },function(err){
    // Error callback
    const loader = document.getElementById("checkout-loader");
    const header = document.querySelector("#checkoutModal .lintels-modal-header");
    const form = document.querySelector("#checkoutModal .lintels-modal-body");
    const footer = document.querySelector("#checkoutModal .lintels-modal-footer");
    const errorDiv = document.querySelector("#checkoutModal #checkout-error");
    const errorMessage = document.querySelector("#checkoutModal #checkout-error #checkout-error-message");
    
    loader.style.display = "none";
    header.style.display = "block";
    form.style.display = "block";
    footer.style.display = "block";
    errorDiv.style.display = "block";
    errorMessage.textContent = "Something went wrong while placing your order. Please try again. If the issue persists, contact our support team.";
  })

}
async function validateAndSubmitSave(){
  let cartTotal = getTotalCartItems(cartState)
  if(cartTotal === 0) return
  if (!validateSaveModal()) {
    return;
  }
  const lineitems = getCheckoutProductDetails();
  // console.log(lineitems); // send this to checkout API

  let cartObject = await getCartItemsObject()
  let cartObjectKeys = Object.keys(cartObject)
  cartObjectKeys = cartObjectKeys.length > 0 ? cartObjectKeys.map(v => parseInt(v)) : []

  // if(!cartObjectKeys.length) return

  lineitems.checkoutItems.forEach(item => {
    if(cartObjectKeys.includes(parseInt(item.variant_id))){
      item.quantity = item.quantity + cartObject[parseInt(item.variant_id)]
    }
  });
  cartObjectKeys.forEach(key => {
    if(!lineitems.variantIds.includes(key)){
      lineitems.checkoutItems.push(
        {
          variant_id: parseInt(key),
          quantity: cartObject[parseInt(key)]
        }
      )
    }
  });

  const header = document.querySelector("#saveQuoteModal .lintels-modal-header");
  const form = document.querySelector("#saveQuoteModal .lintels-modal-body");
  const footer = document.querySelector("#saveQuoteModal .lintels-modal-footer");
  const loader = document.getElementById("save-loader");

  header.style.display = "none";
  form.style.display = "none";
  footer.style.display = "none";
  loader.style.display = "flex";

  const formData = {
    firstName: document.getElementById("firstName-save").value.trim(),
    lastName: document.getElementById("lastName-save").value.trim(),
    companyName: document.getElementById("companyName-save").value.trim(),
    email: document.getElementById("email-save").value.trim(),
    phone: document.getElementById("phone-save").value.trim(),
    when_required: jQuery('#whenRequired-save').val().trim(),
  };

  let shipping_address = {};
  if (formData.firstName) shipping_address.first_name = formData.firstName;
  if (formData.lastName) shipping_address.last_name = formData.lastName;
  if (formData.companyName) shipping_address.company = formData.companyName;
  if (formData.phone) shipping_address.phone = formData.phone;
  shipping_address.country = 'Australia'

  let payload = {
      email: formData.email,
      first_name: formData.firstName,
      last_name: formData.lastName,
      note: `Customized Lintels Order\n Material required on: ${formData.when_required}`,
      line_items:lineitems.checkoutItems,
  }

  Object.keys(shipping_address).length > 0 ? payload.shipping_address = shipping_address : '';

  createSaveDraftOrder(payload,async function(res){
    const loader = document.getElementById("save-loader");
    const header = document.querySelector("#saveQuoteModal .lintels-modal-header");
    const form = document.querySelector("#saveQuoteModal .lintels-modal-body");
    const footer = document.querySelector("#saveQuoteModal .lintels-modal-footer");
    const errorDiv = document.querySelector("#saveQuoteModal #save-error");
    const errorMessage = document.querySelector("#saveQuoteModal #save-error #save-error-message");

    loader.querySelector('.spinner').style.display = 'none'
    loader.querySelector('p').textContent = 'Your quote request has been recieved, the team will contact you shortly'
    await clearCart()
    setTimeout(() => {
      header.style.display = "block";
      form.style.display = "block";
      footer.style.display = "block";
      loader.querySelector('.spinner').style.display = 'block'
      loader.querySelector('p').textContent = 'Please wait...'
      closeModal('saveQuoteModal')
      resetWholeForm()
    },1000)
  },function(err){
    // Error callback
    const loader = document.getElementById("save-loader");
    const header = document.querySelector("#saveQuoteModal .lintels-modal-header");
    const form = document.querySelector("#saveQuoteModal .lintels-modal-body");
    const footer = document.querySelector("#saveQuoteModal .lintels-modal-footer");
    const errorDiv = document.querySelector("#saveQuoteModal #save-error");
    const errorMessage = document.querySelector("#saveQuoteModal #save-error #save-error-message");
    
    loader.style.display = "none";
    header.style.display = "block";
    form.style.display = "block";
    footer.style.display = "block";
    errorDiv.style.display = "block";
    errorMessage.textContent = "Something went wrong while sending you quote request. Please try again. If the issue persists, contact our support team.";
  })

}
function clearFormErrors() {
  document.querySelectorAll(".error-message").forEach((el) => {
    el.textContent = "";
  });
}
function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
function validateCheckoutModal() {
  clearFormErrors();
  let isValid = true;

  const firstName = document.getElementById("firstName").value.trim();
  const lastName = document.getElementById("lastName").value.trim();
  const companyName = document.getElementById("companyName").value.trim();
  const email = document.getElementById("email").value.trim();
  const phone = document.getElementById("phone").value.trim();

  // First Name validation
  if (!firstName) {
    document.getElementById("firstName-error").textContent = "First Name is required";
    isValid = false;
  }

  // Last Name validation
  if (!lastName) {
    document.getElementById("lastName-error").textContent = "Last Name is required";
    isValid = false;
  }
  // Company Name validation
  if (!companyName) {
    document.getElementById("companyName-error").textContent = "Company Name is required";
    isValid = false;
  }

  // Email validation
  if (!email) {
    document.getElementById("email-error").textContent = "Email is required";
    isValid = false;
  } else if (!isValidEmail(email)) {
    document.getElementById("email-error").textContent = "Please enter a valid email";
    isValid = false;
  }

  // Phone validation
  if (!phone) {
    document.getElementById("phone-error").textContent = "Phone Number is required";
    isValid = false;
  }

  return isValid;
}
function validateSaveModal() {
  clearFormErrors();
  let isValid = true;

  const firstName = document.getElementById("firstName-save").value.trim();
  const lastName = document.getElementById("lastName-save").value.trim();
  const companyName = document.getElementById("companyName-save").value.trim();
  const email = document.getElementById("email-save").value.trim();
  const phone = document.getElementById("phone-save").value.trim();
  const when_required = document.getElementById("whenRequired-save").value.trim();

  // First Name validation
  if (!firstName) {
    document.getElementById("firstName-save-error").textContent = "First Name is required";
    isValid = false;
  }

  // Last Name validation
  if (!lastName) {
    document.getElementById("lastName-save-error").textContent = "Last Name is required";
    isValid = false;
  }
  // Company Name validation
  if (!companyName) {
    document.getElementById("companyName-save-error").textContent = "Company Name is required";
    isValid = false;
  }

  // Email validation
  if (!email) {
    document.getElementById("email-save-error").textContent = "Email is required";
    isValid = false;
  } else if (!isValidEmail(email)) {
    document.getElementById("email-save-error").textContent = "Please enter a valid email";
    isValid = false;
  }

  // Phone validation
  if (!phone) {
    document.getElementById("phone-save-error").textContent = "Phone Number is required";
    isValid = false;
  }

  if (!when_required) {
    document.getElementById("whenRequired-save-error").textContent = "Date is required";
    isValid = false;
  }else{
    let currentDate = new Date()
    let fDate = new Date(document.getElementById("whenRequired-save").value.trim())
    if(fDate == 'Invalid Date'){
      document.getElementById("whenRequired-save-error").textContent = "Please provide a valid date";
      isValid = false;
    }else{
      if(currentDate >= fDate){
        document.getElementById("whenRequired-save-error").textContent = "Please provide a future date";
        isValid = false;
      }
    }
  }

  return isValid;
}

// ======================= MOBILE CART HANDLERS ======================= //
function initializeMobileCart() {
  const reviewCartBtn = document.getElementById('reviewCartBtn');
  const reviewCartBtnFloating = document.getElementById('reviewFloatingCartBtn');
  const cartDrawerClose = document.getElementById('cartDrawerClose');
  const cartDrawerOverlay = document.getElementById('cartDrawerOverlay');
  
  reviewCartBtn.addEventListener('click', openCartDrawer);
  reviewCartBtnFloating.addEventListener('click', openCartDrawer);
  cartDrawerClose.addEventListener('click', closeCartDrawer);
  cartDrawerOverlay.addEventListener('click', closeCartDrawer);
}

function openCartDrawer() {
  const drawer = document.getElementById('cartDrawer');
  const overlay = document.getElementById('cartDrawerOverlay');
  const body = document.querySelector('body')
  drawer.classList.add('active');
  overlay.classList.add('active');
  body.classList.add('scroll-locked')
}

function closeCartDrawer() {
  const drawer = document.getElementById('cartDrawer');
  const overlay = document.getElementById('cartDrawerOverlay');
  const body = document.querySelector('body')
  drawer.classList.remove('active');
  overlay.classList.remove('active');
  body.classList.remove('scroll-locked')
}

function updateMobileCart(isEmpty) {
  const cartEmptyDrawer = document.querySelector(".cart-empty-drawer");
  const cartItemsContainerDrawer = document.querySelector(".cart-items-container-drawer");
  const cartItemsListDrawer = document.querySelector(".cart-items-list-drawer");
  const cartTotalAmountDrawer = document.querySelector(".cart-total-amount-drawer");

  if (!cartItemsListDrawer) return;

  if (isEmpty) {
    if (cartEmptyDrawer) cartEmptyDrawer.style.display = "block";
    if (cartItemsContainerDrawer) cartItemsContainerDrawer.style.display = "none";
    if (cartTotalAmountDrawer) cartTotalAmountDrawer.textContent = "$0.00";
    cartItemsListDrawer.innerHTML = "";
    return;
  }

  if (cartEmptyDrawer) cartEmptyDrawer.style.display = "none";
  if (cartItemsContainerDrawer) cartItemsContainerDrawer.style.display = "block";

  cartItemsListDrawer.innerHTML = "";
  const currency = GLOBAL_CATALOG?.meta?.currency ?? "$";
  const defaultPrice = GLOBAL_CATALOG?.meta?.defaultPrice ?? 0;

  let total = 0;

  const sectionRegistry = {};
  const groupRegistry = {};

  function getOrCreateSection(sectionKey, sectionLabel) {
    if (sectionRegistry[sectionKey]) return sectionRegistry[sectionKey];

    const section = document.createElement("div");
    section.className = "cart-section";
    section.dataset.key = sectionKey;

    const heading = document.createElement("h1");
    heading.className = "cart-section-heading";
    heading.textContent = sectionLabel;
    section.appendChild(heading);

    cartItemsListDrawer.appendChild(section);
    sectionRegistry[sectionKey] = section;
    return section;
  }

  function getOrCreateGroup({ sectionKey, sectionLabel, cateKey, cateLabel, subCate, productLabel }) {
    const key = `${subCate || "none"}|${productLabel}`;

    if (!groupRegistry[sectionKey]) groupRegistry[sectionKey] = {};
    if (groupRegistry[sectionKey][cateKey]) {
      if (groupRegistry[sectionKey][cateKey][key]) {
        return groupRegistry[sectionKey][cateKey][key];
      }
    }

    const section = getOrCreateSection(sectionKey, sectionLabel);
    let mainGroup = "";
    const cateHeading = document.createElement("h1");
    if (!groupRegistry[sectionKey][cateKey]) {
      mainGroup = document.createElement("div");
      mainGroup.className = "cart-cate-group";
      mainGroup.dataset.key = cateKey;

      cateHeading.className = "main-cate-heading";
      cateHeading.textContent = cateLabel ?? formatTitle(cateKey);

      mainGroup.appendChild(cateHeading);
    } else {
      mainGroup = section.querySelector(`.cart-cate-group[data-key="${cateKey}"]`);
    }

    const group = document.createElement("div");
    group.className = "cart-group";
    group.dataset.key = key;

    const header = document.createElement("div");
    header.className = "cart-group-header";

    const subCateHeading = document.createElement("h2");
    subCateHeading.className = "sub-cate-heading";

    if (productLabel) {
      if (subCate) {
        subCateHeading.textContent = `${formatTitle(subCate)} • ${productLabel}`;
      } else {
        subCateHeading.textContent = `${productLabel}`;
      }
    } else {
      subCateHeading.textContent = subCate ? formatTitle(subCate) : "";
    }

    if (subCateHeading.textContent) header.appendChild(subCateHeading);

    const itemsContainer = document.createElement("div");
    itemsContainer.className = "cart-group-items";

    group.appendChild(header);
    group.appendChild(itemsContainer);
    mainGroup.appendChild(group);
    section.appendChild(mainGroup);

    if (!groupRegistry[sectionKey][cateKey]) groupRegistry[sectionKey][cateKey] = {};
    groupRegistry[sectionKey][cateKey][key] = itemsContainer;
    return itemsContainer;
  }

  function appendLineItemRow(container, { leftText, rightText }, typeId, familyId = null, productId, length, variantId, price, qty = "0") {
    const row = document.createElement("div");
    row.className = "cart-item-row";

    const contentContainer = document.createElement("div");
    contentContainer.className = "cart-item-content-container";

    const qtyContainer = document.createElement("div");
    qtyContainer.className = "cart-item-quantity-selector-container";

    const left = document.createElement("div");
    left.className = "cart-item-left";
    left.innerHTML = leftText;

    const right = document.createElement("div");
    right.className = "cart-item-right";
    right.textContent = rightText;

    const qtySelector = document.createElement("div");
    qtySelector.className = "quantity-selector";

    const minusBtn = document.createElement("button");
    minusBtn.className = "qty-btn";
    minusBtn.textContent = "−";
    minusBtn.addEventListener("click", () => {
      decrementQuantity(typeId, familyId, productId, length, variantId);
    });

    const qtyInput = document.createElement("input");
    qtyInput.className = "qty-input";
    qtyInput.type = "text";
    qtyInput.value = qty;
    qtyInput.readOnly = true;
    qtyInput.dataset.typeId = typeId;
    qtyInput.dataset.familyId = familyId || "";
    qtyInput.dataset.variantId = productId;
    qtyInput.dataset.length = length;
    qtyInput.dataset.price = price;

    const plusBtn = document.createElement("button");
    plusBtn.className = "qty-btn";
    plusBtn.textContent = "+";
    plusBtn.addEventListener("click", () => {
      incrementQuantity(typeId, familyId, productId, length, price, variantId);
    });

    qtySelector.appendChild(minusBtn);
    qtySelector.appendChild(qtyInput);
    qtySelector.appendChild(plusBtn);

    contentContainer.appendChild(left);
    contentContainer.appendChild(right);
    qtyContainer.appendChild(qtySelector);
    row.appendChild(contentContainer);
    row.appendChild(qtyContainer);
    container.appendChild(row);
  }

  function appendAccessoriesLineItemRow(container, { leftText, rightText }, typeId, productId, variantId, price, qty = "0", prodObj) {
    const row = document.createElement("div");
    row.className = "cart-item-row";

    const contentContainer = document.createElement("div");
    contentContainer.className = "cart-item-content-container";

    const qtyContainer = document.createElement("div");
    qtyContainer.className = "cart-item-quantity-selector-container";

    const left = document.createElement("div");
    left.className = "cart-item-left";
    left.innerHTML = leftText;

    const right = document.createElement("div");
    right.className = "cart-item-right";
    right.textContent = rightText;

    const qtySelector = document.createElement("div");
    qtySelector.className = "quantity-selector";

    const minusBtn = document.createElement("button");
    minusBtn.className = "qty-btn";
    minusBtn.textContent = "−";
    minusBtn.addEventListener("click", () => {
      const variantData = getSelectedVariantData(prodObj, null, variantId);
      if (!variantData) {
        alert("This variant combination is not available. Please select a different option.");
        return;
      }
      decrementAccessoryQuantity(typeId, productId, variantData.variantId);
    });

    const qtyInput = document.createElement("input");
    qtyInput.className = "qty-input";
    qtyInput.type = "text";
    qtyInput.value = qty;
    qtyInput.readOnly = true;
    qtyInput.dataset.categoryId = typeId;
    qtyInput.dataset.productId = productId;
    qtyInput.dataset.variantId = variantId;
    qtyInput.dataset.price = price;

    const plusBtn = document.createElement("button");
    plusBtn.className = "qty-btn";
    plusBtn.textContent = "+";
    plusBtn.addEventListener("click", () => {
      const variantData = getSelectedVariantData(prodObj, null, variantId);
      if (!variantData) {
        alert("This variant combination is not available. Please select a different option.");
        return;
      }
      incrementAccessoryQuantity(
        typeId,
        productId,
        prodObj.label,
        variantData.variantId,
        variantData.variantTitle,
        variantData.price
      );
    });

    qtySelector.appendChild(minusBtn);
    qtySelector.appendChild(qtyInput);
    qtySelector.appendChild(plusBtn);

    contentContainer.appendChild(left);
    contentContainer.appendChild(right);
    qtyContainer.appendChild(qtySelector);
    row.appendChild(contentContainer);
    row.appendChild(qtyContainer);
    container.appendChild(row);
  }

  const mp = cartState?.mainProducts || {};

  for (const cateKey of Object.keys(mp)) {
    const cateObj = mp[cateKey];
    if (!cateObj || typeof cateObj !== "object") continue;

    const topValues = Object.values(cateObj);
    const looksLikeFamilies = topValues.some(
      (v) => v && typeof v === "object" && !Array.isArray(v)
    );

    if (looksLikeFamilies) {
      for (const subCateKey of Object.keys(cateObj)) {
        const productsMap = cateObj[subCateKey];
        if (!productsMap || typeof productsMap !== "object") continue;

        for (const prodId of Object.keys(productsMap)) {
          const linesArr = productsMap[prodId];
          const lineItems = normalizeMainLineItems(linesArr);
          if (!lineItems.length) continue;
          lineItems.sort((a, b) => a.length - b.length);
          const productLabel =
            getProductLabelById(cateKey, subCateKey, prodId) || String(prodId);

          const groupContainer = getOrCreateGroup({
            sectionKey: "mainProducts",
            sectionLabel: "Lintels & T-Bars",
            cateKey,
            subCate: subCateKey,
            productLabel,
          });

          lineItems.forEach(({ typeId, familyId, productId, length, quantity, variantId, price }) => {
            const itemPrice =
              getMainProductPrice({
                cate: cateKey,
                subCate: subCateKey,
                prodID: prodId,
                lengthValue: length,
              }) ?? defaultPrice;

            total += itemPrice * quantity;

            appendLineItemRow(groupContainer, {
              leftText: `<b>${quantity}</b> x ${length}mm`,
              rightText: formatCurrency(itemPrice * quantity)
              // `${currency}${(itemPrice * quantity).toFixed(2)}`,
            }, typeId, familyId, productId, length, variantId, price, quantity);
          });
        }
      }
    } else {
      for (const prodId of Object.keys(cateObj)) {
        const linesArr = cateObj[prodId];
        const lineItems = normalizeMainLineItems(linesArr);
        if (!lineItems.length) continue;

        const productLabel = getProductLabelById(cateKey, "", prodId) || String(prodId);

        const groupContainer = getOrCreateGroup({
          sectionKey: "mainProducts",
          sectionLabel: "Lintels & T-Bars",
          cateKey,
          subCate: "",
          productLabel,
        });

        lineItems.forEach(({ typeId, familyId, productId, length, quantity, variantId, price }) => {
          const itemPrice =
            getMainProductPrice({
              cate: cateKey,
              subCate: "",
              prodID: prodId,
              lengthValue: length,
            }) ?? defaultPrice;

          total += itemPrice * quantity;

          appendLineItemRow(groupContainer, {
            leftText: `<b>${quantity}</b> x ${length}mm`,
            rightText: formatCurrency(itemPrice * quantity)
            // `${currency}${(itemPrice * quantity).toFixed(2)}`,
          }, typeId, familyId, productId, length, variantId, price, quantity);
        });
      }
    }
  }

  const acc = cartState?.accessories || {};
  for (const accCateKey of Object.keys(acc)) {
    const categoryObj = acc[accCateKey];
    const items = normalizeAccessoryLineItems(categoryObj);
    if (!items.length) continue;

    items.forEach(({ cateId, prodId, variantId, qty, price, variantName }) => {
      let prodObj = getAccessoryLabelByProductId(accCateKey, prodId);
      const productLabel = prodObj ? prodObj.label : String(prodId);

      const groupContainer = getOrCreateGroup({
        sectionKey: "accessories",
        sectionLabel: "Accessories",
        cateKey: accCateKey,
        cateLabel: GLOBAL_CATALOG?.accessories?.[accCateKey]?.label,
        subCate: "",
        productLabel,
      });

      const details = variantId
        ? getAccessoryVariantDetailsById(accCateKey, prodId, variantId)
        : null;
      const unitPrice =
        typeof price === "number"
          ? price
          : (details?.price ?? getAccessoryPriceByProductId(accCateKey, prodId) ?? defaultPrice);
      const variantLabel = variantName || details?.title;

      total += unitPrice * qty;

      appendAccessoriesLineItemRow(groupContainer, {
        leftText: variantLabel ? `<b>${qty}</b> x ${variantLabel}` : `Qty x ${qty}`,
        rightText: formatCurrency(unitPrice * qty)
        // `${currency}${(unitPrice * qty).toFixed(2)}`,
      }, cateId, prodId, variantId, price, qty, prodObj);
    });
  }

  if (cartTotalAmountDrawer) {
    cartTotalAmountDrawer.textContent = formatCurrency(total)
    // `${currency}${total.toFixed(2)}`;
  }
}